export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: any; output: any; }
  DateTime: { input: any; output: any; }
  Decimal: { input: any; output: any; }
  JSON: { input: any; output: any; }
  UUID: { input: any; output: any; }
  Upload: { input: any; output: any; }
};

export type AdFilter = {
  AND?: InputMaybe<AdFilter>;
  DISTINCT?: InputMaybe<Scalars['Boolean']['input']>;
  NOT?: InputMaybe<AdFilter>;
  OR?: InputMaybe<AdFilter>;
  excludeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  reflectionCategories?: InputMaybe<Array<Scalars['ID']['input']>>;
  showIn?: InputMaybe<AdsShowInEnumListFilterLookup>;
};

export type AdImageType = Node & {
  __typename?: 'AdImageType';
  device: Scalars['String']['output'];
  /** The Globally Unique ID of this object */
  id: Scalars['ID']['output'];
  image: Scalars['String']['output'];
  pk: Scalars['Int']['output'];
};

export type AdMutationPayload = {
  __typename?: 'AdMutationPayload';
  ad: Maybe<AdType>;
  errors: Array<ErrorType>;
};

export type AdType = Node & {
  __typename?: 'AdType';
  /** The Globally Unique ID of this object */
  id: Scalars['ID']['output'];
  images: Array<AdImageType>;
  pk: Scalars['Int']['output'];
  title: Scalars['String']['output'];
  url: Scalars['String']['output'];
  zone: Scalars['String']['output'];
};

/** A connection to a list of items. */
export type AdTypeConnection = {
  __typename?: 'AdTypeConnection';
  /** Contains the nodes in this connection */
  edges: Array<AdTypeEdge>;
  /** Pagination data for this connection */
  pageInfo: PageInfo;
  /** Total quantity of existing nodes. */
  totalCount: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type AdTypeEdge = {
  __typename?: 'AdTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: AdType;
};

export type AddFullKitToCartMutationPayload = {
  __typename?: 'AddFullKitToCartMutationPayload';
  cartLine: Maybe<CartLineType>;
  product: Maybe<ProductType>;
  quantity: Scalars['Int']['output'];
  supplyLinesJson: Scalars['JSON']['output'];
  variant: Maybe<ProductVariantType>;
};

export type AddKitToCartMutationPayload = {
  __typename?: 'AddKitToCartMutationPayload';
  cartLine: Maybe<CartLineType>;
  errors: Array<ErrorType>;
  product: Maybe<ProductType>;
  quantity: Scalars['Int']['output'];
  supplyLinesJson: Scalars['JSON']['output'];
  variant: Maybe<ProductVariantType>;
};

export type AddVariantToCartMutationPayload = {
  __typename?: 'AddVariantToCartMutationPayload';
  cartLine: Maybe<CartLineType>;
  errors: Array<ErrorType>;
  product: Maybe<ProductType>;
  quantity: Scalars['Int']['output'];
  variant: Maybe<ProductVariantType>;
};

export type AddressInput = {
  city: Scalars['String']['input'];
  companyName?: InputMaybe<Scalars['String']['input']>;
  country: Scalars['String']['input'];
  countryArea?: InputMaybe<Scalars['String']['input']>;
  defaultAddress?: InputMaybe<Scalars['Boolean']['input']>;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  postalCode: Scalars['String']['input'];
  streetAddress1: Scalars['String']['input'];
  streetAddress2?: InputMaybe<Scalars['String']['input']>;
};

export type AddressMutationPayload = {
  __typename?: 'AddressMutationPayload';
  address: Maybe<AddressType>;
  errors: Array<ErrorType>;
};

export type AddressType = Node & {
  __typename?: 'AddressType';
  city: Scalars['String']['output'];
  cityArea: Scalars['String']['output'];
  companyName: Scalars['String']['output'];
  country: Scalars['String']['output'];
  countryArea: Scalars['String']['output'];
  countryAreas: Array<Scalars['String']['output']>;
  defaultAddress: Scalars['Boolean']['output'];
  defaultBillingAddress: Scalars['Boolean']['output'];
  defaultShippingAddress: Scalars['Boolean']['output'];
  externalId: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  /** The Globally Unique ID of this object */
  id: Scalars['ID']['output'];
  lastName: Scalars['String']['output'];
  phone: Scalars['String']['output'];
  pk: Scalars['Int']['output'];
  postalCode: Scalars['String']['output'];
  streetAddress1: Scalars['String']['output'];
  streetAddress2: Scalars['String']['output'];
};

/** A connection to a list of items. */
export type AddressTypeConnection = {
  __typename?: 'AddressTypeConnection';
  /** Contains the nodes in this connection */
  edges: Array<AddressTypeEdge>;
  /** Pagination data for this connection */
  pageInfo: PageInfo;
  /** Total quantity of existing nodes. */
  totalCount: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type AddressTypeEdge = {
  __typename?: 'AddressTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: AddressType;
};

export enum AdsShowInEnum {
  BlogArticle = 'BLOG_ARTICLE',
  BlogCategory = 'BLOG_CATEGORY',
  Checkout = 'CHECKOUT',
  MainPage = 'MAIN_PAGE',
  SalePage = 'SALE_PAGE',
  SearchPage = 'SEARCH_PAGE',
  ShoppingBag = 'SHOPPING_BAG'
}

export type AdsShowInEnumListFilterLookup = {
  /** Case-sensitive containment test. Filter will be skipped on `null` value */
  contains?: InputMaybe<Array<AdsShowInEnum>>;
  /** Case-sensitive ends-with. Filter will be skipped on `null` value */
  endsWith?: InputMaybe<Array<AdsShowInEnum>>;
  /** Exact match. Filter will be skipped on `null` value */
  exact?: InputMaybe<Array<AdsShowInEnum>>;
  /** Case-insensitive containment test. Filter will be skipped on `null` value */
  iContains?: InputMaybe<Array<AdsShowInEnum>>;
  /** Case-insensitive ends-with. Filter will be skipped on `null` value */
  iEndsWith?: InputMaybe<Array<AdsShowInEnum>>;
  /** Case-insensitive exact match. Filter will be skipped on `null` value */
  iExact?: InputMaybe<Array<AdsShowInEnum>>;
  /** Case-insensitive regular expression match. Filter will be skipped on `null` value */
  iRegex?: InputMaybe<Array<AdsShowInEnum>>;
  /** Case-insensitive starts-with. Filter will be skipped on `null` value */
  iStartsWith?: InputMaybe<Array<AdsShowInEnum>>;
  /** Exact match of items in a given list. Filter will be skipped on `null` value */
  inList?: InputMaybe<Array<Array<AdsShowInEnum>>>;
  /** Assignment test. Filter will be skipped on `null` value */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Case-sensitive regular expression match. Filter will be skipped on `null` value */
  regex?: InputMaybe<Array<AdsShowInEnum>>;
  /** Case-sensitive starts-with. Filter will be skipped on `null` value */
  startsWith?: InputMaybe<Array<AdsShowInEnum>>;
};

export type AttachOrderToUserMutationPayload = {
  __typename?: 'AttachOrderToUserMutationPayload';
  errors: Array<Scalars['String']['output']>;
};

export enum AttributeDataTypeEnum {
  Float = 'FLOAT',
  Integer = 'INTEGER',
  String = 'STRING'
}

export type AttributeInputType = {
  maxValue?: InputMaybe<Scalars['Float']['input']>;
  minValue?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  values?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type AttributeSchemaType = Node & {
  __typename?: 'AttributeSchemaType';
  dataType: AttributeDataTypeEnum;
  /** The Globally Unique ID of this object */
  id: Scalars['ID']['output'];
  isCollapsed: Scalars['Boolean']['output'];
  isPublished: Scalars['Boolean']['output'];
  maxValue: Scalars['Float']['output'];
  minValue: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  pk: Scalars['Int']['output'];
  values: Array<AttributeSchemaValueType>;
  widgetType: AttributeWidgetTypeEnum;
};

export type AttributeSchemaValueType = Node & {
  __typename?: 'AttributeSchemaValueType';
  blue: Scalars['Int']['output'];
  green: Scalars['Int']['output'];
  /** The Globally Unique ID of this object */
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  pk: Scalars['Int']['output'];
  publicName: Maybe<Scalars['String']['output']>;
  red: Scalars['Int']['output'];
};

export enum AttributeWidgetTypeEnum {
  Button = 'BUTTON',
  ColorSelect = 'COLOR_SELECT',
  List = 'LIST',
  Range = 'RANGE',
  Select = 'SELECT'
}

export type AuthorizationKeyType = Node & {
  __typename?: 'AuthorizationKeyType';
  /** The Globally Unique ID of this object */
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type BalanceTransactionFilter = {
  AND?: InputMaybe<BalanceTransactionFilter>;
  DISTINCT?: InputMaybe<Scalars['Boolean']['input']>;
  NOT?: InputMaybe<BalanceTransactionFilter>;
  OR?: InputMaybe<BalanceTransactionFilter>;
  amount?: InputMaybe<DecimalComparisonFilterLookup>;
  transactionType?: InputMaybe<TransactionTypeEnum>;
};

export type BalanceTransactionType = Node & {
  __typename?: 'BalanceTransactionType';
  amount: Scalars['Decimal']['output'];
  balance: DollarTransactionBalanceType;
  date: Maybe<Scalars['DateTime']['output']>;
  /** The Globally Unique ID of this object */
  id: Scalars['ID']['output'];
  localAmount: Scalars['Decimal']['output'];
  order: Maybe<OrderType>;
  orderLineData: Scalars['JSON']['output'];
  pk: Scalars['Int']['output'];
  transactionType: TransactionTypeEnum;
  userBalance: Scalars['Decimal']['output'];
};

/** A connection to a list of items. */
export type BalanceTransactionTypeConnection = {
  __typename?: 'BalanceTransactionTypeConnection';
  /** Contains the nodes in this connection */
  edges: Array<BalanceTransactionTypeEdge>;
  /** Pagination data for this connection */
  pageInfo: PageInfo;
  /** Total quantity of existing nodes. */
  totalCount: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type BalanceTransactionTypeEdge = {
  __typename?: 'BalanceTransactionTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: BalanceTransactionType;
};

export type BannerCategoryType = Node & {
  __typename?: 'BannerCategoryType';
  created: Scalars['DateTime']['output'];
  /** The Globally Unique ID of this object */
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  pk: Scalars['Int']['output'];
  sortOrder: Scalars['Int']['output'];
};

export type BannerImageType = Node & {
  __typename?: 'BannerImageType';
  alt: Scalars['String']['output'];
  annotation: Scalars['String']['output'];
  buttonTitle: Scalars['String']['output'];
  categoryId: Maybe<Scalars['ID']['output']>;
  description: Scalars['String']['output'];
  fontColor: Scalars['String']['output'];
  /** The Globally Unique ID of this object */
  id: Scalars['ID']['output'];
  link: Scalars['String']['output'];
  mobileThumbnailUrl: Maybe<Scalars['String']['output']>;
  order: Scalars['Int']['output'];
  pk: Scalars['Int']['output'];
  sortOrder: Scalars['Int']['output'];
  thumbnailUrl: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  useInSlider: Scalars['Boolean']['output'];
};


export type BannerImageTypeMobileThumbnailUrlArgs = {
  method?: VersatileImageMethodEnum;
  size?: Scalars['String']['input'];
};


export type BannerImageTypeThumbnailUrlArgs = {
  method?: VersatileImageMethodEnum;
  size?: Scalars['String']['input'];
};

export type BlogArticleCreateInput = {
  annotation?: InputMaybe<Scalars['String']['input']>;
  body?: InputMaybe<Scalars['String']['input']>;
  categories: Array<Scalars['Int']['input']>;
  image: Scalars['Upload']['input'];
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  status: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type BlogArticleFilter = {
  AND?: InputMaybe<BlogArticleFilter>;
  DISTINCT?: InputMaybe<Scalars['Boolean']['input']>;
  NOT?: InputMaybe<BlogArticleFilter>;
  OR?: InputMaybe<BlogArticleFilter>;
  author?: InputMaybe<DjangoModelFilterInput>;
  categories?: InputMaybe<BlogCategoryFilter>;
  dateAdded?: InputMaybe<DatetimeDatetimeFilterLookup>;
  slug?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<StrFilterLookup>;
};

export type BlogArticleMeasurePayload = {
  __typename?: 'BlogArticleMeasurePayload';
  article: BlogArticleType;
};

export type BlogArticleMutationPayload = {
  __typename?: 'BlogArticleMutationPayload';
  blogArticle: Maybe<BlogArticleType>;
  errors: Array<ErrorType>;
};

export type BlogArticleOrder = {
  dateAdded?: InputMaybe<Ordering>;
  datePublished?: InputMaybe<Ordering>;
  featured?: InputMaybe<Ordering>;
  title?: InputMaybe<Ordering>;
};

export type BlogArticleType = Node & {
  __typename?: 'BlogArticleType';
  annotation: Scalars['String']['output'];
  author: UserType;
  authorName: Maybe<Scalars['String']['output']>;
  authorPk: Scalars['Int']['output'];
  averageRating: Scalars['Int']['output'];
  body: Scalars['String']['output'];
  categories: Array<BlogCategoryType>;
  dateAdded: Scalars['DateTime']['output'];
  datePublished: Maybe<Scalars['DateTime']['output']>;
  /** The Globally Unique ID of this object */
  id: Scalars['ID']['output'];
  image: BlogImageType;
  keywords: Scalars['String']['output'];
  pk: Scalars['Int']['output'];
  slug: Scalars['String']['output'];
  status: Scalars['String']['output'];
  tags: Scalars['String']['output'];
  thumbnailUrl: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  userMeasure: Scalars['Int']['output'];
};


export type BlogArticleTypeCategoriesArgs = {
  filters?: InputMaybe<BlogCategoryFilter>;
};


export type BlogArticleTypeThumbnailUrlArgs = {
  method?: VersatileImageMethodEnum;
  size?: Scalars['String']['input'];
};

/** A connection to a list of items. */
export type BlogArticleTypeConnection = {
  __typename?: 'BlogArticleTypeConnection';
  /** Contains the nodes in this connection */
  edges: Array<BlogArticleTypeEdge>;
  /** Pagination data for this connection */
  pageInfo: PageInfo;
  /** Total quantity of existing nodes. */
  totalCount: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type BlogArticleTypeEdge = {
  __typename?: 'BlogArticleTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: BlogArticleType;
};

export type BlogArticleTypeOffsetPaginated = {
  __typename?: 'BlogArticleTypeOffsetPaginated';
  pageInfo: OffsetPaginationInfo;
  /** List of paginated results. */
  results: Array<BlogArticleType>;
  /** Total count of existing results. */
  totalCount: Scalars['Int']['output'];
};

export type BlogArticleUpdateInput = {
  annotation?: InputMaybe<Scalars['String']['input']>;
  body?: InputMaybe<Scalars['String']['input']>;
  categories: Array<Scalars['Int']['input']>;
  image?: InputMaybe<Scalars['Upload']['input']>;
  pk: Scalars['Int']['input'];
  slug?: InputMaybe<Scalars['String']['input']>;
  status: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type BlogArticleUploadPayload = {
  __typename?: 'BlogArticleUploadPayload';
  fileName: Maybe<Scalars['String']['output']>;
  url: Maybe<Scalars['String']['output']>;
};

export type BlogCategoryFilter = {
  AND?: InputMaybe<BlogCategoryFilter>;
  DISTINCT?: InputMaybe<Scalars['Boolean']['input']>;
  NOT?: InputMaybe<BlogCategoryFilter>;
  OR?: InputMaybe<BlogCategoryFilter>;
  blog?: InputMaybe<BlogFilter>;
  id?: InputMaybe<IdBaseFilterLookup>;
  name?: InputMaybe<StrFilterLookup>;
  slug?: InputMaybe<StrFilterLookup>;
};

export type BlogCategoryType = Node & {
  __typename?: 'BlogCategoryType';
  articles: BlogArticleTypeConnection;
  blog: BlogType;
  description: Scalars['String']['output'];
  /** The Globally Unique ID of this object */
  id: Scalars['ID']['output'];
  image: BlogImageType;
  isPublished: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  pk: Scalars['Int']['output'];
  slug: Scalars['String']['output'];
  sortOrder: Maybe<Scalars['Int']['output']>;
  thumbnailUrl: Maybe<Scalars['String']['output']>;
};


export type BlogCategoryTypeArticlesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<BlogArticleFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  ordering?: Array<BlogArticleOrder>;
};


export type BlogCategoryTypeThumbnailUrlArgs = {
  method?: VersatileImageMethodEnum;
  size?: Scalars['String']['input'];
};

/** A connection to a list of items. */
export type BlogCategoryTypeConnection = {
  __typename?: 'BlogCategoryTypeConnection';
  /** Contains the nodes in this connection */
  edges: Array<BlogCategoryTypeEdge>;
  /** Pagination data for this connection */
  pageInfo: PageInfo;
  /** Total quantity of existing nodes. */
  totalCount: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type BlogCategoryTypeEdge = {
  __typename?: 'BlogCategoryTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: BlogCategoryType;
};

export type BlogFilter = {
  AND?: InputMaybe<BlogFilter>;
  DISTINCT?: InputMaybe<Scalars['Boolean']['input']>;
  NOT?: InputMaybe<BlogFilter>;
  OR?: InputMaybe<BlogFilter>;
  isWholesale?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<StrFilterLookup>;
};

export type BlogImageType = {
  __typename?: 'BlogImageType';
  url: Scalars['String']['output'];
};

export type BlogSubscriberInput = {
  blogPk: Scalars['Int']['input'];
  email: Scalars['String']['input'];
};

export type BlogSubscriberPayload = {
  __typename?: 'BlogSubscriberPayload';
  blog: BlogType;
};

export type BlogType = Node & {
  __typename?: 'BlogType';
  categories: Array<BlogCategoryType>;
  description: Scalars['String']['output'];
  /** The Globally Unique ID of this object */
  id: Scalars['ID']['output'];
  image: BlogImageType;
  isWholesale: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  pk: Scalars['Int']['output'];
  slug: Scalars['String']['output'];
  subscribed: Scalars['Boolean']['output'];
};


export type BlogTypeCategoriesArgs = {
  filters?: InputMaybe<BlogCategoryFilter>;
};

/** A connection to a list of items. */
export type BlogTypeConnection = {
  __typename?: 'BlogTypeConnection';
  /** Contains the nodes in this connection */
  edges: Array<BlogTypeEdge>;
  /** Pagination data for this connection */
  pageInfo: PageInfo;
  /** Total quantity of existing nodes. */
  totalCount: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type BlogTypeEdge = {
  __typename?: 'BlogTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: BlogType;
};

export type BoolBaseFilterLookup = {
  /** Exact match. Filter will be skipped on `null` value */
  exact?: InputMaybe<Scalars['Boolean']['input']>;
  /** Exact match of items in a given list. Filter will be skipped on `null` value */
  inList?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  /** Assignment test. Filter will be skipped on `null` value */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CartClearMutationPayload = {
  __typename?: 'CartClearMutationPayload';
  cart: Maybe<CartType>;
  errors: Array<ErrorType>;
  success: Scalars['Boolean']['output'];
};

export type CartLineFilter = {
  AND?: InputMaybe<CartLineFilter>;
  DISTINCT?: InputMaybe<Scalars['Boolean']['input']>;
  NOT?: InputMaybe<CartLineFilter>;
  OR?: InputMaybe<CartLineFilter>;
  categories?: InputMaybe<Array<Scalars['Int']['input']>>;
  id?: InputMaybe<IdBaseFilterLookup>;
  supply?: InputMaybe<CartLineFilter>;
};

export type CartLinePriceType = {
  __typename?: 'CartLinePriceType';
  currency: Scalars['String']['output'];
  discount: Scalars['Float']['output'];
  undiscount: Scalars['Float']['output'];
};

export type CartLineType = Node & {
  __typename?: 'CartLineType';
  /** The Globally Unique ID of this object */
  id: Scalars['ID']['output'];
  isShippingRequired: Scalars['Boolean']['output'];
  pk: Scalars['Int']['output'];
  quantity: Scalars['Int']['output'];
  supply: Maybe<CartLineType>;
  supplyParts: Array<CartLineType>;
  total: PriceType;
  unitPrice: CartLinePriceType;
  variant: ProductVariantType;
};


export type CartLineTypeSupplyPartsArgs = {
  filters?: InputMaybe<CartLineFilter>;
};

export type CartLineTypeOffsetPaginated = {
  __typename?: 'CartLineTypeOffsetPaginated';
  pageInfo: OffsetPaginationInfo;
  /** List of paginated results. */
  results: Array<CartLineType>;
  /** Total count of existing results. */
  totalCount: Scalars['Int']['output'];
};

export type CartLinesUpdateBySupplyMutationPayload = {
  __typename?: 'CartLinesUpdateBySupplyMutationPayload';
  cart: Maybe<CartType>;
  errors: Array<ErrorType>;
};

export type CartShipmentType = Node & {
  __typename?: 'CartShipmentType';
  cart: CartType;
  countryRecipient: Scalars['String']['output'];
  /** The Globally Unique ID of this object */
  id: Scalars['ID']['output'];
  packageInfo: Scalars['JSON']['output'];
  pk: Scalars['Int']['output'];
  price: PriceType;
  shipmentType: Scalars['String']['output'];
  shippingMethod: ShippingMethodType;
  stateRecipient: Scalars['String']['output'];
};

export type CartTotalPriceType = {
  __typename?: 'CartTotalPriceType';
  currency: Scalars['String']['output'];
  discount: PriceType;
  discountUsd: PriceType;
  earnPoints: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  promoCodeApplied: Scalars['Float']['output'];
  undiscount: PriceType;
};

export type CartType = Node & {
  __typename?: 'CartType';
  allLines: Array<CartLineType>;
  cookieToken: Scalars['String']['output'];
  count: Scalars['Int']['output'];
  created: Scalars['DateTime']['output'];
  email: Maybe<Scalars['String']['output']>;
  /** The Globally Unique ID of this object */
  id: Scalars['ID']['output'];
  lastStatusChange: Scalars['DateTime']['output'];
  lines: CartLineTypeOffsetPaginated;
  linesByCategory: Scalars['JSON']['output'];
  order: Maybe<OrderType>;
  orderId: Maybe<Scalars['Int']['output']>;
  pk: Scalars['UUID']['output'];
  quantity: Scalars['Int']['output'];
  salesChannel: MarketplaceShopType;
  shippingDiscounts: Array<ShippingDiscountType>;
  status: Scalars['String']['output'];
  token: Scalars['UUID']['output'];
  total: PriceType;
  totalPrice: CartTotalPriceType;
  type: CartTypeEnum;
  user: UserType;
};


export type CartTypeAllLinesArgs = {
  filters?: InputMaybe<CartLineFilter>;
};


export type CartTypeLinesArgs = {
  filters?: InputMaybe<CartLineFilter>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};


export type CartTypeTotalPriceArgs = {
  promoCodeToken?: InputMaybe<Scalars['String']['input']>;
};

export enum CartTypeEnum {
  Default = 'DEFAULT',
  Wholesale = 'WHOLESALE'
}

export type CartUpdateKitMutationPayload = {
  __typename?: 'CartUpdateKitMutationPayload';
  errors: Array<Scalars['String']['output']>;
};

export type CartUpdateVariantMutationPayload = {
  __typename?: 'CartUpdateVariantMutationPayload';
  errors: Array<ErrorType>;
};

export type CategoryFilter = {
  AND?: InputMaybe<CategoryFilter>;
  DISTINCT?: InputMaybe<Scalars['Boolean']['input']>;
  NOT?: InputMaybe<CategoryFilter>;
  OR?: InputMaybe<CategoryFilter>;
  id?: InputMaybe<IdBaseFilterLookup>;
  level?: InputMaybe<IntComparisonFilterLookup>;
  slug?: InputMaybe<StrFilterLookup>;
};

export type CategoryImageType = Node & {
  __typename?: 'CategoryImageType';
  alt: Scalars['String']['output'];
  /** The Globally Unique ID of this object */
  id: Scalars['ID']['output'];
  image: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  pk: Scalars['Int']['output'];
};

export type CategoryProductsCountType = Node & {
  __typename?: 'CategoryProductsCountType';
  /** The Globally Unique ID of this object */
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  pk: Scalars['Int']['output'];
  specCount: Scalars['Int']['output'];
};

export type CategorySchemaType = Node & {
  __typename?: 'CategorySchemaType';
  count: Scalars['Int']['output'];
  /** The Globally Unique ID of this object */
  id: Scalars['ID']['output'];
  level: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  parentId: Maybe<Scalars['Int']['output']>;
  pk: Scalars['Int']['output'];
  slug: Scalars['String']['output'];
};

export type CategoryType = Node & {
  __typename?: 'CategoryType';
  children: Array<CategoryType>;
  description: Scalars['String']['output'];
  /** The Globally Unique ID of this object */
  id: Scalars['ID']['output'];
  images: Array<CategoryImageType>;
  isFeatured: Scalars['Boolean']['output'];
  isWholesale: Scalars['Boolean']['output'];
  keywords: Scalars['String']['output'];
  level: Scalars['Int']['output'];
  metaDescription: Scalars['String']['output'];
  metaTitle: Scalars['String']['output'];
  name: Scalars['String']['output'];
  parent: Maybe<CategoryType>;
  parentId: Maybe<Scalars['Int']['output']>;
  pk: Scalars['Int']['output'];
  productSpecifics: ProductSiteSpecificsTypeConnection;
  productsDataFile: Maybe<ProductsDataFileType>;
  relatedCount: Scalars['Int']['output'];
  slug: Scalars['String']['output'];
  sortOrder: Maybe<Scalars['Int']['output']>;
  thumbnail: ThumbnailType;
  thumbnailUrl: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};


export type CategoryTypeChildrenArgs = {
  filters?: InputMaybe<CategoryFilter>;
};


export type CategoryTypeProductSpecificsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<ProductSiteSpecificsFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  ordering?: Array<ProductSiteSpecificsOrder>;
};


export type CategoryTypeThumbnailUrlArgs = {
  method?: VersatileImageMethodEnum;
  size?: Scalars['String']['input'];
};

export type ChangeInfoMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
};

export type ChangePasswordInput = {
  newPassword1: Scalars['String']['input'];
  newPassword2: Scalars['String']['input'];
  oldPassword: Scalars['String']['input'];
};

export type CheckoutAddressInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  country: Scalars['String']['input'];
  countryArea?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  streetAddress1?: InputMaybe<Scalars['String']['input']>;
  streetAddress2?: InputMaybe<Scalars['String']['input']>;
};

export type CheckoutFormInput = {
  billingAddress?: InputMaybe<CheckoutAddressInput>;
  billingAddressId?: InputMaybe<Scalars['Int']['input']>;
  billingAsShipping?: InputMaybe<Scalars['Boolean']['input']>;
  cartShipmentId?: InputMaybe<Scalars['Int']['input']>;
  draft?: InputMaybe<Scalars['Boolean']['input']>;
  email: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  paymentMethodId: Scalars['Int']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  promoCode?: InputMaybe<Scalars['String']['input']>;
  shippingAddress?: InputMaybe<CheckoutAddressInput>;
  shippingAddressId?: InputMaybe<Scalars['Int']['input']>;
  shippingMethodId?: InputMaybe<Scalars['Int']['input']>;
  voucherCode?: InputMaybe<Scalars['String']['input']>;
};

export type CollectionFilter = {
  AND?: InputMaybe<CollectionFilter>;
  DISTINCT?: InputMaybe<Scalars['Boolean']['input']>;
  NOT?: InputMaybe<CollectionFilter>;
  OR?: InputMaybe<CollectionFilter>;
  id?: InputMaybe<IdBaseFilterLookup>;
  slug?: InputMaybe<StrFilterLookup>;
};

export type CollectionSchemaType = Node & {
  __typename?: 'CollectionSchemaType';
  /** The Globally Unique ID of this object */
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  pk: Scalars['Int']['output'];
  slug: Scalars['String']['output'];
};

export type CollectionType = Node & {
  __typename?: 'CollectionType';
  availableFrom: Maybe<Scalars['Date']['output']>;
  availableTo: Maybe<Scalars['Date']['output']>;
  /** The Globally Unique ID of this object */
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  sortOrder: Scalars['Int']['output'];
  subtitle: Scalars['String']['output'];
  thumbnail: ThumbnailType;
  thumbnailUrl: Maybe<Scalars['String']['output']>;
};


export type CollectionTypeThumbnailUrlArgs = {
  method?: VersatileImageMethodEnum;
  size?: Scalars['String']['input'];
};

/** A connection to a list of items. */
export type CollectionTypeConnection = {
  __typename?: 'CollectionTypeConnection';
  /** Contains the nodes in this connection */
  edges: Array<CollectionTypeEdge>;
  /** Pagination data for this connection */
  pageInfo: PageInfo;
  /** Total quantity of existing nodes. */
  totalCount: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type CollectionTypeEdge = {
  __typename?: 'CollectionTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: CollectionType;
};

export type ConditionAfterVerificationType = {
  __typename?: 'ConditionAfterVerificationType';
  label: Scalars['String']['output'];
  status: PromoCodeConditionStatusEnum;
  variant: PromoCodeConditionVariantEnum;
};

export type ContactInputType = {
  captcha: Scalars['String']['input'];
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  policyAgreement: Scalars['Boolean']['input'];
  subject: Scalars['String']['input'];
  text: Scalars['String']['input'];
};

export type ContactMutationPayload = {
  __typename?: 'ContactMutationPayload';
  errors: Array<ErrorType>;
};

export enum CountryCodeEnum {
  Ad = 'AD',
  Ae = 'AE',
  Af = 'AF',
  Ag = 'AG',
  Ai = 'AI',
  Al = 'AL',
  Am = 'AM',
  Ao = 'AO',
  Aq = 'AQ',
  Ar = 'AR',
  As = 'AS',
  At = 'AT',
  Au = 'AU',
  Aw = 'AW',
  Ax = 'AX',
  Az = 'AZ',
  A = 'A_',
  Ba = 'BA',
  Bb = 'BB',
  Bd = 'BD',
  Be = 'BE',
  Bf = 'BF',
  Bg = 'BG',
  Bh = 'BH',
  Bi = 'BI',
  Bj = 'BJ',
  Bl = 'BL',
  Bm = 'BM',
  Bn = 'BN',
  Bo = 'BO',
  Bq = 'BQ',
  Br = 'BR',
  Bs = 'BS',
  Bt = 'BT',
  Bv = 'BV',
  Bw = 'BW',
  By = 'BY',
  Bz = 'BZ',
  Ca = 'CA',
  Cc = 'CC',
  Cd = 'CD',
  Cf = 'CF',
  Cg = 'CG',
  Ch = 'CH',
  Ci = 'CI',
  Ck = 'CK',
  Cl = 'CL',
  Cm = 'CM',
  Cn = 'CN',
  Co = 'CO',
  Cr = 'CR',
  Cu = 'CU',
  Cv = 'CV',
  Cw = 'CW',
  Cx = 'CX',
  Cy = 'CY',
  Cz = 'CZ',
  De = 'DE',
  Dj = 'DJ',
  Dk = 'DK',
  Dm = 'DM',
  Do = 'DO',
  Dz = 'DZ',
  Ec = 'EC',
  Ee = 'EE',
  Eg = 'EG',
  Eh = 'EH',
  Er = 'ER',
  Es = 'ES',
  Et = 'ET',
  Fi = 'FI',
  Fj = 'FJ',
  Fk = 'FK',
  Fm = 'FM',
  Fo = 'FO',
  Fr = 'FR',
  Ga = 'GA',
  Gb = 'GB',
  Gd = 'GD',
  Ge = 'GE',
  Gf = 'GF',
  Gg = 'GG',
  Gh = 'GH',
  Gi = 'GI',
  Gl = 'GL',
  Gm = 'GM',
  Gn = 'GN',
  Gp = 'GP',
  Gq = 'GQ',
  Gr = 'GR',
  Gs = 'GS',
  Gt = 'GT',
  Gu = 'GU',
  Gw = 'GW',
  Gy = 'GY',
  Hk = 'HK',
  Hm = 'HM',
  Hn = 'HN',
  Hr = 'HR',
  Ht = 'HT',
  Hu = 'HU',
  Id = 'ID',
  Ie = 'IE',
  Il = 'IL',
  Im = 'IM',
  In = 'IN',
  Io = 'IO',
  Iq = 'IQ',
  Ir = 'IR',
  Is = 'IS',
  It = 'IT',
  Je = 'JE',
  Jm = 'JM',
  Jo = 'JO',
  Jp = 'JP',
  Ke = 'KE',
  Kg = 'KG',
  Kh = 'KH',
  Ki = 'KI',
  Km = 'KM',
  Kn = 'KN',
  Kp = 'KP',
  Kr = 'KR',
  Kw = 'KW',
  Ky = 'KY',
  Kz = 'KZ',
  La = 'LA',
  Lb = 'LB',
  Lc = 'LC',
  Li = 'LI',
  Lk = 'LK',
  Lr = 'LR',
  Ls = 'LS',
  Lt = 'LT',
  Lu = 'LU',
  Lv = 'LV',
  Ly = 'LY',
  Ma = 'MA',
  Mc = 'MC',
  Md = 'MD',
  Me = 'ME',
  Mf = 'MF',
  Mg = 'MG',
  Mh = 'MH',
  Mk = 'MK',
  Ml = 'ML',
  Mm = 'MM',
  Mn = 'MN',
  Mo = 'MO',
  Mp = 'MP',
  Mq = 'MQ',
  Mr = 'MR',
  Ms = 'MS',
  Mt = 'MT',
  Mu = 'MU',
  Mv = 'MV',
  Mw = 'MW',
  Mx = 'MX',
  My = 'MY',
  Mz = 'MZ',
  Na = 'NA',
  Nc = 'NC',
  Ne = 'NE',
  Nf = 'NF',
  Ng = 'NG',
  Ni = 'NI',
  Nl = 'NL',
  No = 'NO',
  Np = 'NP',
  Nr = 'NR',
  Nu = 'NU',
  Nz = 'NZ',
  Om = 'OM',
  Pa = 'PA',
  Pe = 'PE',
  Pf = 'PF',
  Pg = 'PG',
  Ph = 'PH',
  Pk = 'PK',
  Pl = 'PL',
  Pm = 'PM',
  Pn = 'PN',
  Pr = 'PR',
  Ps = 'PS',
  Pt = 'PT',
  Pw = 'PW',
  Py = 'PY',
  Qa = 'QA',
  Re = 'RE',
  Ro = 'RO',
  Rs = 'RS',
  Ru = 'RU',
  Rw = 'RW',
  Sa = 'SA',
  Sb = 'SB',
  Sc = 'SC',
  Sd = 'SD',
  Se = 'SE',
  Sg = 'SG',
  Sh = 'SH',
  Si = 'SI',
  Sj = 'SJ',
  Sk = 'SK',
  Sl = 'SL',
  Sm = 'SM',
  Sn = 'SN',
  So = 'SO',
  Sr = 'SR',
  Ss = 'SS',
  St = 'ST',
  Sv = 'SV',
  Sx = 'SX',
  Sy = 'SY',
  Sz = 'SZ',
  Tc = 'TC',
  Td = 'TD',
  Tf = 'TF',
  Tg = 'TG',
  Th = 'TH',
  Tj = 'TJ',
  Tk = 'TK',
  Tl = 'TL',
  Tm = 'TM',
  Tn = 'TN',
  To = 'TO',
  Tr = 'TR',
  Tt = 'TT',
  Tv = 'TV',
  Tw = 'TW',
  Tz = 'TZ',
  Ua = 'UA',
  Ug = 'UG',
  Um = 'UM',
  Us = 'US',
  Uy = 'UY',
  Uz = 'UZ',
  Va = 'VA',
  Vc = 'VC',
  Ve = 'VE',
  Vg = 'VG',
  Vi = 'VI',
  Vn = 'VN',
  Vu = 'VU',
  Wf = 'WF',
  Ws = 'WS',
  Ye = 'YE',
  Yt = 'YT',
  Za = 'ZA',
  Zm = 'ZM',
  Zw = 'ZW'
}

export type CreateCustomerInput = {
  captcha: Scalars['String']['input'];
  email: Scalars['String']['input'];
};

export type CreateOrderNoteMutationPayload = {
  __typename?: 'CreateOrderNoteMutationPayload';
  errors: Array<Scalars['String']['output']>;
  note: Maybe<OrderNoteType>;
};

export type CreateOwnTranslationInput = {
  firstIndexes: Array<Scalars['Int']['input']>;
  languageToTranslate: Scalars['String']['input'];
  lastIndexes: Array<Scalars['Int']['input']>;
  textsReplaced: Array<Scalars['String']['input']>;
  textsToReplace: Array<Scalars['String']['input']>;
  translationId: Scalars['ID']['input'];
};

export type CreateOwnTranslationMutationPayload = {
  __typename?: 'CreateOwnTranslationMutationPayload';
  errors: Array<ErrorType>;
};

export type CreditFormInput = {
  creditPk: Scalars['ID']['input'];
  paymentMethod: Scalars['ID']['input'];
};

export type CreditMutationPayload = {
  __typename?: 'CreditMutationPayload';
  errors: Array<ErrorType>;
  extraData: Maybe<Scalars['JSON']['output']>;
  order: Maybe<OrderType>;
  paymentToken: Maybe<Scalars['String']['output']>;
  paymentVariant: Maybe<PaymentVariantEnum>;
  token: Maybe<Scalars['String']['output']>;
  url: Maybe<Scalars['String']['output']>;
};

export type CurrencyExchangeRateType = Node & {
  __typename?: 'CurrencyExchangeRateType';
  currencyCode: Scalars['String']['output'];
  /** The Globally Unique ID of this object */
  id: Scalars['ID']['output'];
  pk: Scalars['Int']['output'];
  rate: Scalars['Float']['output'];
};

export type CustomerChangeSubscriptionsInput = {
  activationCode: Scalars['String']['input'];
  subscriptionTypes?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type CustomerDiscountType = Node & {
  __typename?: 'CustomerDiscountType';
  /** The Globally Unique ID of this object */
  id: Scalars['ID']['output'];
  localValue: Scalars['Decimal']['output'];
  pk: Scalars['Int']['output'];
  value: Scalars['Decimal']['output'];
};

export type CustomerMutationPayload = {
  __typename?: 'CustomerMutationPayload';
  customer: Maybe<MarketplaceCustomerType>;
  errors: Array<ErrorType>;
};

export type CustomerSubscriptionType = Node & {
  __typename?: 'CustomerSubscriptionType';
  description: Scalars['String']['output'];
  /** The Globally Unique ID of this object */
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  pk: Scalars['Int']['output'];
  sortOrder: Scalars['Int']['output'];
  subscriptionType: SubscriptionTypeEnum;
};

export type DatetimeDatetimeFilterLookup = {
  date?: InputMaybe<IntComparisonFilterLookup>;
  day?: InputMaybe<IntComparisonFilterLookup>;
  /** Exact match. Filter will be skipped on `null` value */
  exact?: InputMaybe<Scalars['DateTime']['input']>;
  /** Greater than. Filter will be skipped on `null` value */
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Greater than or equal to. Filter will be skipped on `null` value */
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  hour?: InputMaybe<IntComparisonFilterLookup>;
  /** Exact match of items in a given list. Filter will be skipped on `null` value */
  inList?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  /** Assignment test. Filter will be skipped on `null` value */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  isoWeekDay?: InputMaybe<IntComparisonFilterLookup>;
  isoYear?: InputMaybe<IntComparisonFilterLookup>;
  /** Less than. Filter will be skipped on `null` value */
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Less than or equal to. Filter will be skipped on `null` value */
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  minute?: InputMaybe<IntComparisonFilterLookup>;
  month?: InputMaybe<IntComparisonFilterLookup>;
  quarter?: InputMaybe<IntComparisonFilterLookup>;
  /** Inclusive range test (between) */
  range?: InputMaybe<DatetimeRangeLookup>;
  second?: InputMaybe<IntComparisonFilterLookup>;
  time?: InputMaybe<IntComparisonFilterLookup>;
  week?: InputMaybe<IntComparisonFilterLookup>;
  weekDay?: InputMaybe<IntComparisonFilterLookup>;
  year?: InputMaybe<IntComparisonFilterLookup>;
};

export type DatetimeRangeLookup = {
  end?: InputMaybe<Scalars['DateTime']['input']>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DecimalComparisonFilterLookup = {
  /** Exact match. Filter will be skipped on `null` value */
  exact?: InputMaybe<Scalars['Decimal']['input']>;
  /** Greater than. Filter will be skipped on `null` value */
  gt?: InputMaybe<Scalars['Decimal']['input']>;
  /** Greater than or equal to. Filter will be skipped on `null` value */
  gte?: InputMaybe<Scalars['Decimal']['input']>;
  /** Exact match of items in a given list. Filter will be skipped on `null` value */
  inList?: InputMaybe<Array<Scalars['Decimal']['input']>>;
  /** Assignment test. Filter will be skipped on `null` value */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than. Filter will be skipped on `null` value */
  lt?: InputMaybe<Scalars['Decimal']['input']>;
  /** Less than or equal to. Filter will be skipped on `null` value */
  lte?: InputMaybe<Scalars['Decimal']['input']>;
  /** Inclusive range test (between) */
  range?: InputMaybe<DecimalRangeLookup>;
};

export type DecimalRangeLookup = {
  end?: InputMaybe<Scalars['Decimal']['input']>;
  start?: InputMaybe<Scalars['Decimal']['input']>;
};

export type DeleteCartLineMutationPayload = {
  __typename?: 'DeleteCartLineMutationPayload';
  cart: Maybe<CartType>;
  errors: Array<ErrorType>;
};

export type DeleteOrderMutationPayload = {
  __typename?: 'DeleteOrderMutationPayload';
  errors: Array<Scalars['String']['output']>;
};

export enum DeliveryGroupDetailStatusEnum {
  Delivered = 'DELIVERED',
  Digital = 'DIGITAL',
  Failed = 'FAILED',
  InTransit = 'IN_TRANSIT',
  NoTracking = 'NO_TRACKING',
  PreTransit = 'PRE_TRANSIT',
  ReturnedToSender = 'RETURNED_TO_SENDER',
  Unavailable = 'UNAVAILABLE'
}

export enum DeliveryGroupStatusEnum {
  Approved = 'APPROVED',
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Draft = 'DRAFT',
  Issue = 'ISSUE',
  NotReceived = 'NOT_RECEIVED',
  Pending = 'PENDING',
  Refunded = 'REFUNDED',
  Unapproved = 'UNAPPROVED'
}

export type DeliveryGroupType = Node & {
  __typename?: 'DeliveryGroupType';
  detailStatus: DeliveryGroupDetailStatusEnum;
  /** The Globally Unique ID of this object */
  id: Scalars['ID']['output'];
  isShippingRequired: Scalars['Boolean']['output'];
  lastUpdated: Maybe<Scalars['DateTime']['output']>;
  lines: Array<OrderLineType>;
  pk: Scalars['Int']['output'];
  shippingMethod: Maybe<ShippingMethodType>;
  shippingMethodName: Maybe<Scalars['String']['output']>;
  status: DeliveryGroupStatusEnum;
  tracking: Array<DeliveryStatusHistoryType>;
  trackingAdditionalInfo: Scalars['String']['output'];
  trackingNumber: Scalars['String']['output'];
};


export type DeliveryGroupTypeLinesArgs = {
  filters?: InputMaybe<OrderLineFilter>;
};

export type DeliveryStatusHistoryType = Node & {
  __typename?: 'DeliveryStatusHistoryType';
  country: Maybe<Scalars['String']['output']>;
  date: Maybe<Scalars['DateTime']['output']>;
  /** The Globally Unique ID of this object */
  id: Scalars['ID']['output'];
  name: Maybe<Scalars['String']['output']>;
  pk: Scalars['Int']['output'];
  status: Maybe<Scalars['String']['output']>;
};

export enum DiscountTypeEnum {
  Fixed = 'FIXED',
  Percentage = 'PERCENTAGE'
}

export type DjangoModelFilterInput = {
  pk: Scalars['ID']['input'];
};

export type DollarTransactionBalanceType = Node & {
  __typename?: 'DollarTransactionBalanceType';
  balance: Scalars['Decimal']['output'];
  /** The Globally Unique ID of this object */
  id: Scalars['ID']['output'];
  pk: Scalars['Int']['output'];
  pointsBalance: Scalars['Float']['output'];
  program: RewardProgramType;
};

export type DownloadType = Node & {
  __typename?: 'DownloadType';
  downloadTime: Scalars['DateTime']['output'];
  fileName: Scalars['String']['output'];
  /** The Globally Unique ID of this object */
  id: Scalars['ID']['output'];
  order: OrderType;
  pk: Scalars['Int']['output'];
};

export type DownloadTypeOffsetPaginated = {
  __typename?: 'DownloadTypeOffsetPaginated';
  pageInfo: OffsetPaginationInfo;
  /** List of paginated results. */
  results: Array<DownloadType>;
  /** Total count of existing results. */
  totalCount: Scalars['Int']['output'];
};

export type DuplicateOrderMutationPayload = {
  __typename?: 'DuplicateOrderMutationPayload';
  duplicate: Maybe<OrderType>;
  errors: Array<Scalars['String']['output']>;
};

export type EditAddressInput = {
  city: Scalars['String']['input'];
  companyName?: InputMaybe<Scalars['String']['input']>;
  country: Scalars['String']['input'];
  countryArea?: InputMaybe<Scalars['String']['input']>;
  defaultAddress?: InputMaybe<Scalars['Boolean']['input']>;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  pk: Scalars['Int']['input'];
  postalCode: Scalars['String']['input'];
  streetAddress1: Scalars['String']['input'];
  streetAddress2?: InputMaybe<Scalars['String']['input']>;
};

export type EditOrderMutationPayload = {
  __typename?: 'EditOrderMutationPayload';
  errors: Array<Scalars['String']['output']>;
  order: Maybe<OrderType>;
};

export type ErrorType = {
  __typename?: 'ErrorType';
  field: Scalars['String']['output'];
  messages: Array<Scalars['String']['output']>;
};

export type FavoriteProductPayload = {
  __typename?: 'FavoriteProductPayload';
  errors: Array<Scalars['String']['output']>;
  product: Maybe<ProductType>;
};

export type FavoritesCategoriesInfoType = {
  __typename?: 'FavoritesCategoriesInfoType';
  category: CategoryType;
  productsCount: Scalars['Int']['output'];
};

export type FeedbackFilter = {
  AND?: InputMaybe<FeedbackFilter>;
  DISTINCT?: InputMaybe<Scalars['Boolean']['input']>;
  NOT?: InputMaybe<FeedbackFilter>;
  OR?: InputMaybe<FeedbackFilter>;
  salesChannel?: InputMaybe<Scalars['ID']['input']>;
  score?: InputMaybe<IntComparisonFilterLookup>;
};

export type FeedbackInputObjectType = {
  comment: Scalars['String']['input'];
  score: Scalars['Int']['input'];
  title: Scalars['String']['input'];
  userName?: InputMaybe<Scalars['String']['input']>;
};

export type FeedbackOrder = {
  salesChannel?: InputMaybe<Ordering>;
  score?: InputMaybe<Ordering>;
  timeCreated?: InputMaybe<Ordering>;
};

export type FeedbackType = Node & {
  __typename?: 'FeedbackType';
  comment: Scalars['String']['output'];
  customer: Maybe<MarketplaceCustomerType>;
  /** The Globally Unique ID of this object */
  id: Scalars['ID']['output'];
  line: Maybe<OrderLineType>;
  pk: Scalars['Int']['output'];
  product: Maybe<ProductType>;
  productName: Scalars['String']['output'];
  published: Scalars['Boolean']['output'];
  salesChannel: MarketplaceShopType;
  score: Scalars['Int']['output'];
  siteSpecifics: Maybe<ProductSiteSpecificsType>;
  timeCreated: Scalars['DateTime']['output'];
  title: Scalars['String']['output'];
  url: Scalars['String']['output'];
  user: Maybe<UserType>;
  userName: Scalars['String']['output'];
};

export type FeedbackTypeOffsetPaginated = {
  __typename?: 'FeedbackTypeOffsetPaginated';
  pageInfo: OffsetPaginationInfo;
  /** List of paginated results. */
  results: Array<FeedbackType>;
  /** Total count of existing results. */
  totalCount: Scalars['Int']['output'];
};

export type FilterSchemaType = {
  __typename?: 'FilterSchemaType';
  attributes: Array<AttributeSchemaType>;
  categories: Array<CategorySchemaType>;
  collections: Array<CollectionSchemaType>;
  maxPrice: Scalars['Float']['output'];
  minPrice: Scalars['Float']['output'];
  saleList: Array<SaleSchemaType>;
};

export type FlatPageFilter = {
  AND?: InputMaybe<FlatPageFilter>;
  DISTINCT?: InputMaybe<Scalars['Boolean']['input']>;
  NOT?: InputMaybe<FlatPageFilter>;
  OR?: InputMaybe<FlatPageFilter>;
  id?: InputMaybe<IdBaseFilterLookup>;
  title?: InputMaybe<StrFilterLookup>;
  url?: InputMaybe<StrFilterLookup>;
};

export type FlatPageType = Node & {
  __typename?: 'FlatPageType';
  content: Scalars['String']['output'];
  enableComments: Scalars['Boolean']['output'];
  /** The Globally Unique ID of this object */
  id: Scalars['ID']['output'];
  pk: Scalars['Int']['output'];
  registrationRequired: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

/** A connection to a list of items. */
export type FlatPageTypeConnection = {
  __typename?: 'FlatPageTypeConnection';
  /** Contains the nodes in this connection */
  edges: Array<FlatPageTypeEdge>;
  /** Pagination data for this connection */
  pageInfo: PageInfo;
  /** Total quantity of existing nodes. */
  totalCount: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type FlatPageTypeEdge = {
  __typename?: 'FlatPageTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: FlatPageType;
};

export type FooterBlockType = Node & {
  __typename?: 'FooterBlockType';
  /** The Globally Unique ID of this object */
  id: Scalars['ID']['output'];
  isFeatured: Scalars['Boolean']['output'];
  links: Array<FooterLinkType>;
  name: Scalars['String']['output'];
  pk: Scalars['Int']['output'];
  sortOrder: Scalars['Int']['output'];
};

export type FooterLinkType = Node & {
  __typename?: 'FooterLinkType';
  bootstrapClass: Scalars['String']['output'];
  /** The Globally Unique ID of this object */
  id: Scalars['ID']['output'];
  linkAddress: Scalars['String']['output'];
  linkText: Scalars['String']['output'];
  pk: Scalars['Int']['output'];
  sortOrder: Scalars['Int']['output'];
};

export type FormErrorsPayload = {
  __typename?: 'FormErrorsPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<ErrorType>;
};

export type GetShippingPricesInput = {
  addressLine1?: InputMaybe<Scalars['String']['input']>;
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  cartType?: CartTypeEnum;
  cityName?: InputMaybe<Scalars['String']['input']>;
  countryTo: CountryCodeEnum;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  provinceCode?: InputMaybe<Scalars['String']['input']>;
  shippingMethodIds: Array<Scalars['Int']['input']>;
};

export type GetShippingPricesMutationPayload = {
  __typename?: 'GetShippingPricesMutationPayload';
  cartShipments: Array<CartShipmentType>;
  errors: Array<ErrorType>;
};

export type GiftCardFormInput = {
  fromEmail: Scalars['String']['input'];
  fromName: Scalars['String']['input'];
  giftCard: Scalars['ID']['input'];
  paymentMethod: Scalars['ID']['input'];
  personalMessage?: InputMaybe<Scalars['String']['input']>;
  toEmail: Scalars['String']['input'];
  toName: Scalars['String']['input'];
};

export type GiftCardMutationPayload = {
  __typename?: 'GiftCardMutationPayload';
  errors: Array<ErrorType>;
  token: Maybe<Scalars['String']['output']>;
  url: Maybe<Scalars['String']['output']>;
};

export type IdBaseFilterLookup = {
  /** Exact match. Filter will be skipped on `null` value */
  exact?: InputMaybe<Scalars['ID']['input']>;
  /** Exact match of items in a given list. Filter will be skipped on `null` value */
  inList?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Assignment test. Filter will be skipped on `null` value */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IntComparisonFilterLookup = {
  /** Exact match. Filter will be skipped on `null` value */
  exact?: InputMaybe<Scalars['Int']['input']>;
  /** Greater than. Filter will be skipped on `null` value */
  gt?: InputMaybe<Scalars['Int']['input']>;
  /** Greater than or equal to. Filter will be skipped on `null` value */
  gte?: InputMaybe<Scalars['Int']['input']>;
  /** Exact match of items in a given list. Filter will be skipped on `null` value */
  inList?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Assignment test. Filter will be skipped on `null` value */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than. Filter will be skipped on `null` value */
  lt?: InputMaybe<Scalars['Int']['input']>;
  /** Less than or equal to. Filter will be skipped on `null` value */
  lte?: InputMaybe<Scalars['Int']['input']>;
  /** Inclusive range test (between) */
  range?: InputMaybe<IntRangeLookup>;
};

export type IntRangeLookup = {
  end?: InputMaybe<Scalars['Int']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
};

export type InvoiceCompanyFileType = Node & {
  __typename?: 'InvoiceCompanyFileType';
  fileUrl: Scalars['String']['output'];
  /** The Globally Unique ID of this object */
  id: Scalars['ID']['output'];
  pk: Scalars['Int']['output'];
  type: Scalars['String']['output'];
};

export type KitFormInput = {
  pk: Scalars['Int']['input'];
  quantity: Scalars['Int']['input'];
};

export enum LanguageEnum {
  De = 'de',
  En = 'en',
  Es = 'es',
  Fr = 'fr',
  Ru = 'ru',
  Uk = 'uk'
}

export type LogoutMutationPayload = {
  __typename?: 'LogoutMutationPayload';
  me: Maybe<UserType>;
};

export type ManufacturerType = Node & {
  __typename?: 'ManufacturerType';
  /** The Globally Unique ID of this object */
  id: Scalars['ID']['output'];
  keyword: Scalars['String']['output'];
  name: Scalars['String']['output'];
  pk: Scalars['Int']['output'];
  sortOrder: Scalars['Int']['output'];
};

export type MarketingCodeType = {
  __typename?: 'MarketingCodeType';
  giftCardCode: Maybe<VoucherTransactionType>;
  promoCode: Maybe<PromoCodeType>;
};


export type MarketingCodeTypeGiftCardCodeArgs = {
  code: Scalars['String']['input'];
};


export type MarketingCodeTypePromoCodeArgs = {
  captcha: Scalars['String']['input'];
  code: Scalars['String']['input'];
  countryCode: CountryCodeEnum;
  email?: InputMaybe<Scalars['String']['input']>;
};

export type MarketingInfoType = {
  __typename?: 'MarketingInfoType';
  positiveFeedbackCount: Scalars['Int']['output'];
  salesCount: Scalars['Int']['output'];
};

export type MarketplaceCustomerType = Node & {
  __typename?: 'MarketplaceCustomerType';
  activationCode: Scalars['String']['output'];
  discount: Maybe<CustomerDiscountType>;
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  /** The Globally Unique ID of this object */
  id: Scalars['ID']['output'];
  lastName: Scalars['String']['output'];
  pk: Scalars['Int']['output'];
  sendNotifications: Scalars['Boolean']['output'];
  shops: Array<MarketplaceShopType>;
  subscribed: Scalars['Boolean']['output'];
  subscriptionTypes: Array<CustomerSubscriptionType>;
  user: UserType;
};

export type MarketplaceShopType = Node & {
  __typename?: 'MarketplaceShopType';
  /** The Globally Unique ID of this object */
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  pk: Scalars['Int']['output'];
};

/** A connection to a list of items. */
export type MarketplaceShopTypeConnection = {
  __typename?: 'MarketplaceShopTypeConnection';
  /** Contains the nodes in this connection */
  edges: Array<MarketplaceShopTypeEdge>;
  /** Pagination data for this connection */
  pageInfo: PageInfo;
  /** Total quantity of existing nodes. */
  totalCount: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type MarketplaceShopTypeEdge = {
  __typename?: 'MarketplaceShopTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: MarketplaceShopType;
};

export type Mutation = {
  __typename?: 'Mutation';
  adClickMutation: AdMutationPayload;
  adImpressionMutation: AdMutationPayload;
  addFullKitToCart: AddFullKitToCartMutationPayload;
  addKitToCart: AddKitToCartMutationPayload;
  addUserAddress: AddressMutationPayload;
  addVariantToCart: AddVariantToCartMutationPayload;
  attachOrderToUser: AttachOrderToUserMutationPayload;
  blogAddSubscriber: BlogSubscriberPayload;
  blogArticleMeasure: BlogArticleMeasurePayload;
  blogArticleUpload: BlogArticleUploadPayload;
  blogRemoveSubscriber: BlogSubscriberPayload;
  cartClear: CartClearMutationPayload;
  cartLinesUpdateBySupply: CartLinesUpdateBySupplyMutationPayload;
  cartUpdateKit: CartUpdateKitMutationPayload;
  cartUpdateVariant: CartUpdateVariantMutationPayload;
  confirmMarketingSubscription: CustomerMutationPayload;
  contact: ContactMutationPayload;
  createBlogArticle: BlogArticleMutationPayload;
  createCustomer: CustomerMutationPayload;
  createOrderNote: CreateOrderNoteMutationPayload;
  createOwnTranslation: CreateOwnTranslationMutationPayload;
  customerChangeSubscriptions: CustomerMutationPayload;
  deleteCartLine: DeleteCartLineMutationPayload;
  deleteOrder: DeleteOrderMutationPayload;
  deleteUserAddress: AddressMutationPayload;
  duplicateOrder: DuplicateOrderMutationPayload;
  editOrder: EditOrderMutationPayload;
  editUserAddress: AddressMutationPayload;
  getShippingPrices: GetShippingPricesMutationPayload;
  logout: LogoutMutationPayload;
  openOrderCart: OpenOrderCartMutationPayload;
  orderCreatePayment: OrderCreatePaymentMutationPayload;
  orderLineLeaveFeedback: OrderLineLeaveFeedbackPayload;
  proceedToPayment: ProceedToPaymentMutationPayload;
  productClicked: Scalars['Boolean']['output'];
  purchaseCredit: CreditMutationPayload;
  purchaseGiftCard: GiftCardMutationPayload;
  purchasePatternPack: PatternPackMutationPayload;
  resetPassword: FormErrorsPayload;
  setCurrency: SetCurrencyPayload;
  setLanguage: SetLanguageMutationPayload;
  signIn: SignInMutationPayload;
  signUp: SignUpMutationPayload;
  socialAuth: SocialAuthPayload;
  socialPostCreate: SocialPostCreatePayload;
  submissionAnalytics: SubmissionAnalyticsPayload;
  supportIssueOpened: Scalars['Boolean']['output'];
  supportIssueResolved: Scalars['Boolean']['output'];
  transferOrderToCheckout: TransferOrderToCheckoutMutationPayload;
  ugcPermissionDeclined: Scalars['Boolean']['output'];
  ugcPermissionGranted: Scalars['Boolean']['output'];
  ugcPhotoSubmitted: Scalars['Boolean']['output'];
  updateBlogArticle: BlogArticleMutationPayload;
  updateUserTranslation: UpdateUserTranslationMutationPayload;
  userAddFavoritesProduct: FavoriteProductPayload;
  userChangeInfo: FormErrorsPayload;
  userChangePassword: FormErrorsPayload;
  userDeleteFavoritesProduct: FavoriteProductPayload;
  userResetPasswordFromKey: FormErrorsPayload;
  wholesaleAppCreate: WholesaleAppCreateMutationPayload;
  wholesaleCheckout: WholesaleCheckoutMutationPayload;
};


export type MutationAdClickMutationArgs = {
  adId: Scalars['ID']['input'];
};


export type MutationAdImpressionMutationArgs = {
  adId: Scalars['ID']['input'];
};


export type MutationAddFullKitToCartArgs = {
  cartType?: CartTypeEnum;
  quantity?: Scalars['Int']['input'];
  variant: Scalars['Int']['input'];
};


export type MutationAddKitToCartArgs = {
  supplyVariant: Scalars['Int']['input'];
  variants: Array<KitFormInput>;
};


export type MutationAddUserAddressArgs = {
  input: AddressInput;
};


export type MutationAddVariantToCartArgs = {
  cartType?: CartTypeEnum;
  quantity: Scalars['Int']['input'];
  variant: Scalars['Int']['input'];
};


export type MutationAttachOrderToUserArgs = {
  token: Scalars['String']['input'];
};


export type MutationBlogAddSubscriberArgs = {
  data: BlogSubscriberInput;
};


export type MutationBlogArticleMeasureArgs = {
  articlePk: Scalars['Int']['input'];
  measure: Scalars['Int']['input'];
};


export type MutationBlogArticleUploadArgs = {
  image: Scalars['Upload']['input'];
};


export type MutationBlogRemoveSubscriberArgs = {
  data: BlogSubscriberInput;
};


export type MutationCartClearArgs = {
  cartType?: CartTypeEnum;
  category?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationCartLinesUpdateBySupplyArgs = {
  cartType?: CartTypeEnum;
  supplyLineId: Scalars['ID']['input'];
};


export type MutationCartUpdateKitArgs = {
  cartLine: Scalars['Int']['input'];
  cartType?: CartTypeEnum;
  variants: Array<KitFormInput>;
};


export type MutationCartUpdateVariantArgs = {
  cartLine: Scalars['Int']['input'];
  cartType?: CartTypeEnum;
  quantity: Scalars['Int']['input'];
  variant: Scalars['Int']['input'];
};


export type MutationConfirmMarketingSubscriptionArgs = {
  activationCode: Scalars['String']['input'];
};


export type MutationContactArgs = {
  input: ContactInputType;
};


export type MutationCreateBlogArticleArgs = {
  input: BlogArticleCreateInput;
};


export type MutationCreateCustomerArgs = {
  input: CreateCustomerInput;
};


export type MutationCreateOrderNoteArgs = {
  input: OrderNoteInput;
};


export type MutationCreateOwnTranslationArgs = {
  input: CreateOwnTranslationInput;
};


export type MutationCustomerChangeSubscriptionsArgs = {
  input: CustomerChangeSubscriptionsInput;
};


export type MutationDeleteCartLineArgs = {
  cartLine?: InputMaybe<Scalars['ID']['input']>;
  cartType?: CartTypeEnum;
  variant?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationDeleteOrderArgs = {
  pk?: InputMaybe<Scalars['Int']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDeleteUserAddressArgs = {
  pk: Scalars['Int']['input'];
};


export type MutationDuplicateOrderArgs = {
  token: Scalars['String']['input'];
};


export type MutationEditOrderArgs = {
  isDraft?: Scalars['Boolean']['input'];
  orderId: Scalars['Int']['input'];
};


export type MutationEditUserAddressArgs = {
  input: EditAddressInput;
};


export type MutationGetShippingPricesArgs = {
  input: GetShippingPricesInput;
};


export type MutationOpenOrderCartArgs = {
  token: Scalars['String']['input'];
};


export type MutationOrderCreatePaymentArgs = {
  paymentMethodId: Scalars['Int']['input'];
  token: Scalars['String']['input'];
};


export type MutationOrderLineLeaveFeedbackArgs = {
  input: FeedbackInputObjectType;
  orderLinePk: Scalars['ID']['input'];
  productPk: Scalars['ID']['input'];
};


export type MutationProceedToPaymentArgs = {
  input: CheckoutFormInput;
};


export type MutationProductClickedArgs = {
  productId: Scalars['Int']['input'];
  source?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};


export type MutationPurchaseCreditArgs = {
  input: CreditFormInput;
};


export type MutationPurchaseGiftCardArgs = {
  input: GiftCardFormInput;
};


export type MutationPurchasePatternPackArgs = {
  input: PatternPackFormInput;
};


export type MutationResetPasswordArgs = {
  input: ResetPasswordMutationInput;
};


export type MutationSetCurrencyArgs = {
  currency: Scalars['String']['input'];
};


export type MutationSetLanguageArgs = {
  input: SetLanguageInput;
};


export type MutationSignInArgs = {
  input: SignInMutationInput;
};


export type MutationSignUpArgs = {
  input: SignUpMutationInput;
};


export type MutationSocialAuthArgs = {
  accessToken: Scalars['String']['input'];
  provider: Scalars['String']['input'];
};


export type MutationSocialPostCreateArgs = {
  externalImages: Array<Scalars['String']['input']>;
  images: Array<Scalars['Upload']['input']>;
  input: SocialPostInput;
};


export type MutationSubmissionAnalyticsArgs = {
  activationCode: Scalars['String']['input'];
  event: Scalars['String']['input'];
  submission: Scalars['ID']['input'];
};


export type MutationSupportIssueOpenedArgs = {
  issueId: Scalars['ID']['input'];
  issueType?: InputMaybe<Scalars['String']['input']>;
  orderId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationSupportIssueResolvedArgs = {
  issueId: Scalars['ID']['input'];
  orderId?: InputMaybe<Scalars['ID']['input']>;
  resolution?: InputMaybe<Scalars['String']['input']>;
};


export type MutationTransferOrderToCheckoutArgs = {
  cartType?: CartTypeEnum;
  token: Scalars['String']['input'];
};


export type MutationUgcPermissionDeclinedArgs = {
  productId?: InputMaybe<Scalars['ID']['input']>;
  reviewId: Scalars['ID']['input'];
};


export type MutationUgcPermissionGrantedArgs = {
  productId?: InputMaybe<Scalars['ID']['input']>;
  reviewId: Scalars['ID']['input'];
};


export type MutationUgcPhotoSubmittedArgs = {
  productId?: InputMaybe<Scalars['ID']['input']>;
  reviewId?: InputMaybe<Scalars['ID']['input']>;
  submissionId: Scalars['ID']['input'];
};


export type MutationUpdateBlogArticleArgs = {
  input: BlogArticleUpdateInput;
};


export type MutationUpdateUserTranslationArgs = {
  input: UpdateUserTranslationInput;
};


export type MutationUserAddFavoritesProductArgs = {
  pk: Scalars['Int']['input'];
};


export type MutationUserChangeInfoArgs = {
  input: ChangeInfoMutationInput;
};


export type MutationUserChangePasswordArgs = {
  input: ChangePasswordInput;
};


export type MutationUserDeleteFavoritesProductArgs = {
  pk: Scalars['Int']['input'];
};


export type MutationUserResetPasswordFromKeyArgs = {
  input?: InputMaybe<PasswordResetInput>;
  token: Scalars['String']['input'];
  uid: Scalars['String']['input'];
};


export type MutationWholesaleAppCreateArgs = {
  wholesaleAppInput: WholesaleAppInput;
};


export type MutationWholesaleCheckoutArgs = {
  input: WholesaleCheckoutFormInput;
};

/** An object with a Globally Unique ID */
export type Node = {
  /** The Globally Unique ID of this object */
  id: Scalars['ID']['output'];
};

export type OfferType = Node & {
  __typename?: 'OfferType';
  description: Scalars['String']['output'];
  /** The Globally Unique ID of this object */
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  sortOrder: Scalars['Int']['output'];
  url: Scalars['String']['output'];
};

/** A connection to a list of items. */
export type OfferTypeConnection = {
  __typename?: 'OfferTypeConnection';
  /** Contains the nodes in this connection */
  edges: Array<OfferTypeEdge>;
  /** Pagination data for this connection */
  pageInfo: PageInfo;
  /** Total quantity of existing nodes. */
  totalCount: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type OfferTypeEdge = {
  __typename?: 'OfferTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: OfferType;
};

export type OffsetPaginationInfo = {
  __typename?: 'OffsetPaginationInfo';
  limit: Maybe<Scalars['Int']['output']>;
  offset: Scalars['Int']['output'];
};

export type OffsetPaginationInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: Scalars['Int']['input'];
};

export type OpenOrderCartMutationPayload = {
  __typename?: 'OpenOrderCartMutationPayload';
  cart: Maybe<CartType>;
  errors: Array<Scalars['String']['output']>;
};

export type OrderCreatePaymentMutationPayload = {
  __typename?: 'OrderCreatePaymentMutationPayload';
  errors: Array<Scalars['String']['output']>;
  extraData: Maybe<Scalars['JSON']['output']>;
  order: Maybe<OrderType>;
  paymentToken: Maybe<Scalars['String']['output']>;
  paymentVariant: Maybe<PaymentVariantEnum>;
  token: Maybe<Scalars['String']['output']>;
  url: Maybe<Scalars['String']['output']>;
};

export type OrderFilter = {
  AND?: InputMaybe<OrderFilter>;
  DISTINCT?: InputMaybe<Scalars['Boolean']['input']>;
  NOT?: InputMaybe<OrderFilter>;
  OR?: InputMaybe<OrderFilter>;
  cartType?: InputMaybe<CartTypeEnum>;
  created?: InputMaybe<DatetimeDatetimeFilterLookup>;
  customerDiscount?: InputMaybe<StrFilterLookup>;
  id?: InputMaybe<IdBaseFilterLookup>;
  paymentStatus?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<DeliveryGroupStatusEnum>;
  token?: InputMaybe<StrFilterLookup>;
  withPoints?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OrderHistoryEntryOrder = {
  date?: InputMaybe<Ordering>;
};

export type OrderHistoryEntryType = Node & {
  __typename?: 'OrderHistoryEntryType';
  content: Scalars['String']['output'];
  date: Scalars['DateTime']['output'];
  /** The Globally Unique ID of this object */
  id: Scalars['ID']['output'];
  pk: Scalars['Int']['output'];
};

export type OrderLineFilter = {
  AND?: InputMaybe<OrderLineFilter>;
  DISTINCT?: InputMaybe<Scalars['Boolean']['input']>;
  NOT?: InputMaybe<OrderLineFilter>;
  OR?: InputMaybe<OrderLineFilter>;
  id?: InputMaybe<IdBaseFilterLookup>;
  supply?: InputMaybe<OrderLineFilter>;
};

export type OrderLineLeaveFeedbackPayload = {
  __typename?: 'OrderLineLeaveFeedbackPayload';
  errors: Array<ErrorType>;
  feedback: Maybe<FeedbackType>;
};

export enum OrderLineStatusEnum {
  Approved = 'APPROVED',
  Delivered = 'DELIVERED',
  Downloaded = 'DOWNLOADED',
  Issue = 'ISSUE',
  NotDownloaded = 'NOT_DOWNLOADED',
  ReturnedToSender = 'RETURNED_TO_SENDER',
  Shipped = 'SHIPPED',
  Unapproved = 'UNAPPROVED'
}

export type OrderLineType = Node & {
  __typename?: 'OrderLineType';
  convertedAmount: Scalars['Decimal']['output'];
  discountAmount: PriceType;
  discountName: Scalars['String']['output'];
  downloads: Array<UserFileDownloadsType>;
  externalId: Scalars['String']['output'];
  hasFeedback: Scalars['Boolean']['output'];
  /** The Globally Unique ID of this object */
  id: Scalars['ID']['output'];
  isCredit: Scalars['Boolean']['output'];
  isShippingRequired: Scalars['Boolean']['output'];
  isSubscription: Scalars['Boolean']['output'];
  originalPriceNet: Scalars['Decimal']['output'];
  pk: Scalars['Int']['output'];
  product: Maybe<ProductType>;
  productName: Scalars['String']['output'];
  productSku: Scalars['String']['output'];
  props: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
  salesChannelProduct: Maybe<ProductSiteSpecificsType>;
  status: OrderLineStatusEnum;
  subscriptionData: Scalars['JSON']['output'];
  subscriptionDateEnd: Maybe<Scalars['Date']['output']>;
  subscriptionDateStart: Maybe<Scalars['Date']['output']>;
  supplyParts: Array<OrderLineType>;
  supplyTotal: PriceType;
  total: PriceType;
  unitCustomDiscount: Scalars['Decimal']['output'];
  unitPriceNet: Scalars['Decimal']['output'];
  variant: Maybe<ProductVariantType>;
};


export type OrderLineTypeSupplyPartsArgs = {
  filters?: InputMaybe<OrderLineFilter>;
};

export type OrderNoteFilter = {
  AND?: InputMaybe<OrderNoteFilter>;
  DISTINCT?: InputMaybe<Scalars['Boolean']['input']>;
  NOT?: InputMaybe<OrderNoteFilter>;
  OR?: InputMaybe<OrderNoteFilter>;
  isPublic?: InputMaybe<BoolBaseFilterLookup>;
  order?: InputMaybe<OrderFilter>;
};

export type OrderNoteInput = {
  content: Scalars['String']['input'];
  orderId: Scalars['Int']['input'];
  replyToMe?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OrderNoteType = Node & {
  __typename?: 'OrderNoteType';
  content: Scalars['String']['output'];
  creator: Scalars['String']['output'];
  date: Scalars['DateTime']['output'];
  /** The Globally Unique ID of this object */
  id: Scalars['ID']['output'];
  isPublic: Scalars['Boolean']['output'];
  pk: Scalars['Int']['output'];
  replyToMe: Scalars['Boolean']['output'];
};

/** A connection to a list of items. */
export type OrderNoteTypeConnection = {
  __typename?: 'OrderNoteTypeConnection';
  /** Contains the nodes in this connection */
  edges: Array<OrderNoteTypeEdge>;
  /** Pagination data for this connection */
  pageInfo: PageInfo;
  /** Total quantity of existing nodes. */
  totalCount: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type OrderNoteTypeEdge = {
  __typename?: 'OrderNoteTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: OrderNoteType;
};

export type OrderType = Node & {
  __typename?: 'OrderType';
  balanceTransactions: Array<BalanceTransactionType>;
  billingAddress: Maybe<AddressType>;
  carts: Array<CartType>;
  checkoutRate: Scalars['Decimal']['output'];
  created: Scalars['DateTime']['output'];
  currency: Scalars['String']['output'];
  customerDiscount: Maybe<CustomerDiscountType>;
  deliveryId: Scalars['String']['output'];
  discountAmount: PriceType;
  externalId: Scalars['String']['output'];
  giftCardData: Scalars['JSON']['output'];
  giftCardTransactions: Array<VoucherTransactionType>;
  groupLastUpdated: Maybe<Scalars['DateTime']['output']>;
  groups: Array<DeliveryGroupType>;
  history: Array<OrderHistoryEntryType>;
  /** The Globally Unique ID of this object */
  id: Scalars['ID']['output'];
  invoiceFiles: Array<InvoiceCompanyFileType>;
  isDelivered: Scalars['Boolean']['output'];
  isFullyPaid: Scalars['Boolean']['output'];
  isGiftCard: Scalars['Boolean']['output'];
  isNotPaid: Scalars['Boolean']['output'];
  isShippingRequired: Scalars['Boolean']['output'];
  lastPayment: Maybe<PaymentType>;
  notes: Array<OrderNoteType>;
  originalShippingPrice: PriceType;
  payments: Array<PaymentType>;
  pk: Scalars['Int']['output'];
  promoCodeTransactions: Array<PromoCodeTransactionType>;
  pubId: Scalars['String']['output'];
  rewardDollars: Array<RewardDollarsType>;
  shippingAddress: Maybe<AddressType>;
  shippingCustomDiscount: Scalars['Decimal']['output'];
  shippingDiscountAmount: PriceType;
  shippingMethodName: Maybe<Scalars['String']['output']>;
  shippingPrice: PriceType;
  status: DeliveryGroupStatusEnum;
  subtotal: PriceType;
  token: Scalars['String']['output'];
  totalNet: Maybe<PriceType>;
  totalTax: Maybe<PriceType>;
  userEmail: Scalars['String']['output'];
  userId: Maybe<Scalars['Int']['output']>;
};


export type OrderTypeBalanceTransactionsArgs = {
  filters?: InputMaybe<BalanceTransactionFilter>;
};


export type OrderTypeGiftCardTransactionsArgs = {
  filters?: InputMaybe<VoucherTransactionFilter>;
};


export type OrderTypeHistoryArgs = {
  ordering?: Array<OrderHistoryEntryOrder>;
};


export type OrderTypeNotesArgs = {
  filters?: InputMaybe<OrderNoteFilter>;
};


export type OrderTypePaymentsArgs = {
  filters?: InputMaybe<PaymentFilter>;
};

/** A connection to a list of items. */
export type OrderTypeConnection = {
  __typename?: 'OrderTypeConnection';
  /** Contains the nodes in this connection */
  edges: Array<OrderTypeEdge>;
  /** Pagination data for this connection */
  pageInfo: PageInfo;
  /** Total quantity of existing nodes. */
  totalCount: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type OrderTypeEdge = {
  __typename?: 'OrderTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: OrderType;
};

export type OrderTypeOffsetPaginated = {
  __typename?: 'OrderTypeOffsetPaginated';
  pageInfo: OffsetPaginationInfo;
  /** List of paginated results. */
  results: Array<OrderType>;
  /** Total count of existing results. */
  totalCount: Scalars['Int']['output'];
};

export enum Ordering {
  Asc = 'ASC',
  AscNullsFirst = 'ASC_NULLS_FIRST',
  AscNullsLast = 'ASC_NULLS_LAST',
  Desc = 'DESC',
  DescNullsFirst = 'DESC_NULLS_FIRST',
  DescNullsLast = 'DESC_NULLS_LAST'
}

export type OrdersCountInfoType = {
  __typename?: 'OrdersCountInfoType';
  approved: Scalars['Int']['output'];
  completed: Scalars['Int']['output'];
  draft: Scalars['Int']['output'];
  issue: Scalars['Int']['output'];
  paid: Scalars['Int']['output'];
  unapproved: Scalars['Int']['output'];
  unpaid: Scalars['Int']['output'];
};

export enum OutOfStockStatusEnum {
  Backorder = 'BACKORDER',
  In = 'IN',
  Out = 'OUT'
}

/** Information to aid in pagination. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor: Maybe<Scalars['String']['output']>;
};

export type PasswordResetInput = {
  newPassword1?: InputMaybe<Scalars['String']['input']>;
  newPassword2?: InputMaybe<Scalars['String']['input']>;
};

export type PatternPackFormInput = {
  paymentMethod: Scalars['ID']['input'];
  pk: Scalars['ID']['input'];
};

export type PatternPackMutationPayload = {
  __typename?: 'PatternPackMutationPayload';
  errors: Array<ErrorType>;
  extraData: Maybe<Scalars['JSON']['output']>;
  order: Maybe<OrderType>;
  paymentToken: Maybe<Scalars['String']['output']>;
  paymentVariant: Maybe<PaymentVariantEnum>;
  token: Maybe<Scalars['String']['output']>;
  url: Maybe<Scalars['String']['output']>;
};

export type PatternPacksInfoType = {
  __typename?: 'PatternPacksInfoType';
  count: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type PaymentFilter = {
  AND?: InputMaybe<PaymentFilter>;
  DISTINCT?: InputMaybe<Scalars['Boolean']['input']>;
  NOT?: InputMaybe<PaymentFilter>;
  OR?: InputMaybe<PaymentFilter>;
  created?: InputMaybe<DatetimeDatetimeFilterLookup>;
  id?: InputMaybe<IdBaseFilterLookup>;
  isOneTime?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PaymentMethodCredentialsType = Node & {
  __typename?: 'PaymentMethodCredentialsType';
  createdAt: Maybe<Scalars['Date']['output']>;
  email: Maybe<Scalars['String']['output']>;
  /** The Globally Unique ID of this object */
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  method: PaymentMethodType;
  pk: Scalars['Int']['output'];
  sandbox: Scalars['Boolean']['output'];
  userName: Scalars['String']['output'];
};

/** A connection to a list of items. */
export type PaymentMethodCredentialsTypeConnection = {
  __typename?: 'PaymentMethodCredentialsTypeConnection';
  /** Contains the nodes in this connection */
  edges: Array<PaymentMethodCredentialsTypeEdge>;
  /** Pagination data for this connection */
  pageInfo: PageInfo;
  /** Total quantity of existing nodes. */
  totalCount: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type PaymentMethodCredentialsTypeEdge = {
  __typename?: 'PaymentMethodCredentialsTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: PaymentMethodCredentialsType;
};

export type PaymentMethodType = Node & {
  __typename?: 'PaymentMethodType';
  baseUrl: Scalars['String']['output'];
  /** The Globally Unique ID of this object */
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  minPrice: PriceType;
  name: Scalars['String']['output'];
  pk: Scalars['Int']['output'];
};

/** A connection to a list of items. */
export type PaymentMethodTypeConnection = {
  __typename?: 'PaymentMethodTypeConnection';
  /** Contains the nodes in this connection */
  edges: Array<PaymentMethodTypeEdge>;
  /** Pagination data for this connection */
  pageInfo: PageInfo;
  /** Total quantity of existing nodes. */
  totalCount: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type PaymentMethodTypeEdge = {
  __typename?: 'PaymentMethodTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: PaymentMethodType;
};

export type PaymentType = Node & {
  __typename?: 'PaymentType';
  capturedAmount: Scalars['Float']['output'];
  created: Scalars['DateTime']['output'];
  currency: Scalars['String']['output'];
  delivery: Scalars['Float']['output'];
  /** The Globally Unique ID of this object */
  id: Scalars['ID']['output'];
  paymentVariant: Maybe<PaymentVariantEnum>;
  pk: Scalars['Int']['output'];
  status: Scalars['String']['output'];
  tax: Scalars['Float']['output'];
  token: Scalars['String']['output'];
  total: Scalars['Float']['output'];
  transactions: Array<TransactionType>;
};


export type PaymentTypeTransactionsArgs = {
  filters?: InputMaybe<TransactionFilter>;
};

export enum PaymentVariantEnum {
  Empty = 'EMPTY',
  EtsyPaypal = 'ETSY_PAYPAL',
  Fondy = 'FONDY',
  Paypal = 'PAYPAL',
  Stripe = 'STRIPE'
}

export type PostType = Node & {
  __typename?: 'PostType';
  created: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  externalLink: Scalars['String']['output'];
  /** The Globally Unique ID of this object */
  id: Scalars['ID']['output'];
  images: Array<SocialPostImageType>;
  link: Scalars['String']['output'];
  name: Scalars['String']['output'];
  relatedProducts: Array<ProductType>;
  sortOrder: Scalars['Int']['output'];
  status: Scalars['String']['output'];
  type: Scalars['String']['output'];
  username: Scalars['String']['output'];
};


export type PostTypeRelatedProductsArgs = {
  filters?: InputMaybe<ProductFilter>;
};

/** A connection to a list of items. */
export type PostTypeConnection = {
  __typename?: 'PostTypeConnection';
  /** Contains the nodes in this connection */
  edges: Array<PostTypeEdge>;
  /** Pagination data for this connection */
  pageInfo: PageInfo;
  /** Total quantity of existing nodes. */
  totalCount: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type PostTypeEdge = {
  __typename?: 'PostTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: PostType;
};

export type PriceType = {
  __typename?: 'PriceType';
  currency: Scalars['String']['output'];
  gross: Scalars['Float']['output'];
};

export type PriceWithDiscountType = {
  __typename?: 'PriceWithDiscountType';
  currency: Scalars['String']['output'];
  discount: Scalars['Float']['output'];
  undiscount: Scalars['Float']['output'];
};

export type ProceedToPaymentMutationPayload = {
  __typename?: 'ProceedToPaymentMutationPayload';
  errors: Array<ErrorType>;
  extraData: Maybe<Scalars['JSON']['output']>;
  order: Maybe<OrderType>;
  paymentToken: Maybe<Scalars['String']['output']>;
  paymentVariant: Maybe<PaymentVariantEnum>;
  token: Maybe<Scalars['String']['output']>;
  url: Maybe<Scalars['String']['output']>;
};

export type ProductFilter = {
  AND?: InputMaybe<ProductFilter>;
  DISTINCT?: InputMaybe<Scalars['Boolean']['input']>;
  NOT?: InputMaybe<ProductFilter>;
  OR?: InputMaybe<ProductFilter>;
  cartToken?: InputMaybe<Scalars['UUID']['input']>;
  categories?: InputMaybe<Array<Scalars['Int']['input']>>;
  collections?: InputMaybe<CollectionFilter>;
  hasWholesaleVariants?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<IdBaseFilterLookup>;
  isMainRelated?: InputMaybe<Scalars['Boolean']['input']>;
  variants?: InputMaybe<ProductVariantFilter>;
};

export type ProductImageType = Node & {
  __typename?: 'ProductImageType';
  alt: Scalars['String']['output'];
  height: Scalars['Int']['output'];
  /** The Globally Unique ID of this object */
  id: Scalars['ID']['output'];
  image: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  pk: Scalars['Int']['output'];
  thumbnail: ThumbnailType;
  thumbnailUrl: Maybe<Scalars['String']['output']>;
  width: Scalars['Int']['output'];
};


export type ProductImageTypeThumbnailUrlArgs = {
  method?: VersatileImageMethodEnum;
  size?: Scalars['String']['input'];
};

export type ProductPriceRangeType = {
  __typename?: 'ProductPriceRangeType';
  currency: Scalars['String']['output'];
  discount: RangeType;
  id: Scalars['ID']['output'];
  undiscount: RangeType;
};

export type ProductSiteSpecificsFilter = {
  AND?: InputMaybe<ProductSiteSpecificsFilter>;
  DISTINCT?: InputMaybe<Scalars['Boolean']['input']>;
  NOT?: InputMaybe<ProductSiteSpecificsFilter>;
  OR?: InputMaybe<ProductSiteSpecificsFilter>;
  attributeData?: InputMaybe<Scalars['String']['input']>;
  cartToken?: InputMaybe<Scalars['String']['input']>;
  categories?: InputMaybe<CategoryFilter>;
  excludeSupplyParts?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<IdBaseFilterLookup>;
  product?: InputMaybe<ProductFilter>;
  promoCode?: InputMaybe<Array<Scalars['Int']['input']>>;
  q?: InputMaybe<Scalars['String']['input']>;
  siteSpecifics?: InputMaybe<Scalars['Boolean']['input']>;
  withSale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProductSiteSpecificsOrder = {
  availableOn?: InputMaybe<Ordering>;
  created?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  onSale?: InputMaybe<Ordering>;
  orderCount?: InputMaybe<Ordering>;
  productIsOutOfStock?: InputMaybe<Ordering>;
  productMaxPrice?: InputMaybe<Ordering>;
  productMinPrice?: InputMaybe<Ordering>;
  productSku?: InputMaybe<Ordering>;
  productUpdatedAt?: InputMaybe<Ordering>;
  productVariantsSales?: InputMaybe<Ordering>;
  relevance?: InputMaybe<Ordering>;
  sortOrder?: InputMaybe<Ordering>;
};

export type ProductSiteSpecificsType = Node & {
  __typename?: 'ProductSiteSpecificsType';
  absoluteUrl: Scalars['String']['output'];
  categories: Array<CategoryType>;
  description: Scalars['String']['output'];
  generatedDescription: Scalars['String']['output'];
  /** The Globally Unique ID of this object */
  id: Scalars['ID']['output'];
  images: Array<ProductSpecificsImageType>;
  isArchive: Scalars['Boolean']['output'];
  isPublished: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  pk: Scalars['Int']['output'];
  product: Maybe<ProductType>;
  shortName: Scalars['String']['output'];
  skipCanonical: Scalars['Boolean']['output'];
  slug: Scalars['String']['output'];
  sortOrder: Maybe<Scalars['Int']['output']>;
  thumbnail: ThumbnailType;
  thumbnailUrl: Maybe<Scalars['String']['output']>;
  videoUrl: Maybe<Scalars['String']['output']>;
};


export type ProductSiteSpecificsTypeCategoriesArgs = {
  filters?: InputMaybe<CategoryFilter>;
};


export type ProductSiteSpecificsTypeThumbnailUrlArgs = {
  method?: VersatileImageMethodEnum;
  size?: Scalars['String']['input'];
};

export type ProductSiteSpecificsTypeConnection = {
  __typename?: 'ProductSiteSpecificsTypeConnection';
  /** Contains the nodes in this connection */
  edges: Array<ProductSiteSpecificsTypeEdge>;
  /** Pagination data for this connection */
  pageInfo: PageInfo;
  /** Total quantity of existing nodes. */
  totalCount: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type ProductSiteSpecificsTypeEdge = {
  __typename?: 'ProductSiteSpecificsTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: ProductSiteSpecificsType;
};

export type ProductSpecificsImageType = Node & {
  __typename?: 'ProductSpecificsImageType';
  alt: Scalars['String']['output'];
  /** The Globally Unique ID of this object */
  id: Scalars['ID']['output'];
  image: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  pk: Scalars['Int']['output'];
};

export type ProductSuggestionType = {
  __typename?: 'ProductSuggestionType';
  id: Scalars['ID']['output'];
  specific: Maybe<ProductSiteSpecificsType>;
  text: Scalars['String']['output'];
};

export type ProductType = Node & {
  __typename?: 'ProductType';
  attrs: Array<Scalars['String']['output']>;
  convertedAmount: Scalars['Float']['output'];
  ean: Scalars['String']['output'];
  feedbacks: FeedbackTypeOffsetPaginated;
  hasVariants: Scalars['Boolean']['output'];
  height: Maybe<Scalars['Float']['output']>;
  /** The Globally Unique ID of this object */
  id: Scalars['ID']['output'];
  images: Array<ProductImageType>;
  isArchive: Scalars['Boolean']['output'];
  isEanVisible: Scalars['Boolean']['output'];
  isInFavorites: Scalars['Boolean']['output'];
  isInPack: Scalars['Boolean']['output'];
  isInStock: Scalars['Boolean']['output'];
  isIsbnVisible: Scalars['Boolean']['output'];
  isLengthVisible: Scalars['Boolean']['output'];
  isOutOfStock: Scalars['Boolean']['output'];
  isShippingRequired: Scalars['Boolean']['output'];
  isSkuVisible: Scalars['Boolean']['output'];
  isUpcVisible: Scalars['Boolean']['output'];
  isWeightVisible: Scalars['Boolean']['output'];
  isbn: Scalars['String']['output'];
  keywords: Scalars['String']['output'];
  length: Maybe<Scalars['Float']['output']>;
  manufacturer: Maybe<ManufacturerType>;
  metaDescription: Scalars['String']['output'];
  name: Scalars['String']['output'];
  outOfStockStatus: OutOfStockStatusEnum;
  pk: Scalars['Int']['output'];
  price: Maybe<PriceType>;
  priceRange: ProductPriceRangeType;
  quantity: Scalars['Int']['output'];
  redirectUrl: Maybe<Scalars['String']['output']>;
  related: Array<ProductType>;
  relatedProducts: Array<ProductType>;
  rewardPrograms: Array<RewardProgramType>;
  showVariantEan: Scalars['Boolean']['output'];
  showVariantIsbn: Scalars['Boolean']['output'];
  showVariantLength: Scalars['Boolean']['output'];
  showVariantSku: Scalars['Boolean']['output'];
  showVariantUpc: Scalars['Boolean']['output'];
  showVariantWeight: Scalars['Boolean']['output'];
  sku: Maybe<Scalars['String']['output']>;
  sortOrder: Maybe<Scalars['Int']['output']>;
  specifics: Array<ProductSiteSpecificsType>;
  subscribedProductsCount: Maybe<Scalars['Int']['output']>;
  tag: Scalars['String']['output'];
  thumbnail: ThumbnailType;
  thumbnailUrl: Maybe<Scalars['String']['output']>;
  upc: Scalars['String']['output'];
  url: Scalars['String']['output'];
  variantImages: Array<ProductImageType>;
  variants: Array<ProductVariantType>;
  variantsProperties: Array<VariationPropertyType>;
  weight: Maybe<Scalars['Float']['output']>;
  wholesaleVariantsCount: Scalars['Int']['output'];
  width: Maybe<Scalars['Float']['output']>;
  zipfileLink: Scalars['String']['output'];
};


export type ProductTypeFeedbacksArgs = {
  filters?: InputMaybe<FeedbackFilter>;
  ordering?: Array<FeedbackOrder>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};


export type ProductTypeRelatedArgs = {
  filters?: InputMaybe<ProductFilter>;
};


export type ProductTypeRelatedProductsArgs = {
  filters?: InputMaybe<ProductFilter>;
};


export type ProductTypeSpecificsArgs = {
  filters?: InputMaybe<ProductSiteSpecificsFilter>;
  ordering?: Array<ProductSiteSpecificsOrder>;
};


export type ProductTypeThumbnailUrlArgs = {
  method?: VersatileImageMethodEnum;
  size?: Scalars['String']['input'];
};


export type ProductTypeVariantsArgs = {
  filters?: InputMaybe<ProductVariantFilter>;
};


export type ProductTypeVariantsPropertiesArgs = {
  isWholesale?: Scalars['Boolean']['input'];
};

/** A connection to a list of items. */
export type ProductTypeConnection = {
  __typename?: 'ProductTypeConnection';
  /** Contains the nodes in this connection */
  edges: Array<ProductTypeEdge>;
  /** Pagination data for this connection */
  pageInfo: PageInfo;
  /** Total quantity of existing nodes. */
  totalCount: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type ProductTypeEdge = {
  __typename?: 'ProductTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: ProductType;
};

export type ProductTypeOffsetPaginated = {
  __typename?: 'ProductTypeOffsetPaginated';
  pageInfo: OffsetPaginationInfo;
  /** List of paginated results. */
  results: Array<ProductType>;
  /** Total count of existing results. */
  totalCount: Scalars['Int']['output'];
};

export type ProductVariantFilter = {
  AND?: InputMaybe<ProductVariantFilter>;
  DISTINCT?: InputMaybe<Scalars['Boolean']['input']>;
  NOT?: InputMaybe<ProductVariantFilter>;
  OR?: InputMaybe<ProductVariantFilter>;
  id?: InputMaybe<IdBaseFilterLookup>;
  isPublished?: InputMaybe<BoolBaseFilterLookup>;
  isSupply?: InputMaybe<BoolBaseFilterLookup>;
  isWholesale?: InputMaybe<BoolBaseFilterLookup>;
  product?: InputMaybe<ProductFilter>;
  sales?: InputMaybe<SaleFilter>;
  shippingRequired?: InputMaybe<BoolBaseFilterLookup>;
  wholesaleEnabled?: InputMaybe<BoolBaseFilterLookup>;
};

export type ProductVariantType = Node & {
  __typename?: 'ProductVariantType';
  allImages: Array<ProductImageType>;
  attributes: Scalars['String']['output'];
  cartLines: Array<Scalars['Int']['output']>;
  cartQuantity: Scalars['Int']['output'];
  customizeKitData: Maybe<Scalars['JSON']['output']>;
  duration: Maybe<Scalars['Int']['output']>;
  durationType: Scalars['String']['output'];
  ean: Scalars['String']['output'];
  heightOverride: Maybe<Scalars['Float']['output']>;
  /** The Globally Unique ID of this object */
  id: Scalars['ID']['output'];
  images: Array<ProductImageType>;
  isCustomizable: Scalars['Boolean']['output'];
  isInCart: Scalars['Boolean']['output'];
  isInStock: Scalars['Boolean']['output'];
  isPublished: Scalars['Boolean']['output'];
  isSupply: Scalars['Boolean']['output'];
  isbn: Scalars['String']['output'];
  itemData: Maybe<Scalars['JSON']['output']>;
  lengthOverride: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  outOfStockStatus: OutOfStockStatusEnum;
  parts: Array<SupplyVariantType>;
  pk: Scalars['Int']['output'];
  price: Maybe<PriceType>;
  priceRange: VariantPriceRangeType;
  product: ProductType;
  properties: Array<VariationPropertyType>;
  shippingRequired: Scalars['Boolean']['output'];
  sku: Scalars['String']['output'];
  stockQuantity: Scalars['Int']['output'];
  stockStatus: Maybe<OutOfStockStatusEnum>;
  supplyProducts: Array<SupplyProductType>;
  sync1cStocks: Scalars['Boolean']['output'];
  thumbnail: ThumbnailType;
  thumbnailUrl: Maybe<Scalars['String']['output']>;
  unitCoeff: Maybe<Scalars['Float']['output']>;
  upc: Scalars['String']['output'];
  weightOverride: Maybe<Scalars['Float']['output']>;
  wholesaleDescription: Scalars['String']['output'];
  wholesaleEnabled: Scalars['Boolean']['output'];
  wholesalePrice: PriceWithDiscountType;
  widthOverride: Maybe<Scalars['Float']['output']>;
};


export type ProductVariantTypeCartLinesArgs = {
  cartType?: CartTypeEnum;
};


export type ProductVariantTypeCartQuantityArgs = {
  cartType?: CartTypeEnum;
};


export type ProductVariantTypeCustomizeKitDataArgs = {
  cartLine?: InputMaybe<Scalars['Int']['input']>;
  cartType?: CartTypeEnum;
};


export type ProductVariantTypeIsInCartArgs = {
  cartType?: CartTypeEnum;
};


export type ProductVariantTypeSupplyProductsArgs = {
  filters?: InputMaybe<SupplyProductFilter>;
};


export type ProductVariantTypeThumbnailUrlArgs = {
  method?: VersatileImageMethodEnum;
  size?: Scalars['String']['input'];
};

/** A connection to a list of items. */
export type ProductVariantTypeConnection = {
  __typename?: 'ProductVariantTypeConnection';
  /** Contains the nodes in this connection */
  edges: Array<ProductVariantTypeEdge>;
  /** Pagination data for this connection */
  pageInfo: PageInfo;
  /** Total quantity of existing nodes. */
  totalCount: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type ProductVariantTypeEdge = {
  __typename?: 'ProductVariantTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: ProductVariantType;
};

export type ProductsDataFileType = Node & {
  __typename?: 'ProductsDataFileType';
  created: Scalars['DateTime']['output'];
  /** The Globally Unique ID of this object */
  id: Scalars['ID']['output'];
  pk: Scalars['Int']['output'];
  resultFile: Maybe<Scalars['String']['output']>;
};

export enum PromoCodeConditionStatusEnum {
  Error = 'ERROR',
  Success = 'SUCCESS',
  Warning = 'WARNING'
}

export enum PromoCodeConditionVariantEnum {
  CountriesExclude = 'COUNTRIES_EXCLUDE',
  CountriesInclude = 'COUNTRIES_INCLUDE',
  Date = 'DATE',
  Orders = 'ORDERS',
  ProductsCount = 'PRODUCTS_COUNT',
  ProductsPrice = 'PRODUCTS_PRICE',
  Registration = 'REGISTRATION'
}

export type PromoCodeFilter = {
  AND?: InputMaybe<PromoCodeFilter>;
  DISTINCT?: InputMaybe<Scalars['Boolean']['input']>;
  NOT?: InputMaybe<PromoCodeFilter>;
  OR?: InputMaybe<PromoCodeFilter>;
  productSpecifics?: InputMaybe<Scalars['ID']['input']>;
  value?: InputMaybe<DecimalComparisonFilterLookup>;
};

export type PromoCodeTransactionType = Node & {
  __typename?: 'PromoCodeTransactionType';
  amount: Scalars['Decimal']['output'];
  balanceData: Scalars['JSON']['output'];
  date: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  /** The Globally Unique ID of this object */
  id: Scalars['ID']['output'];
  pk: Scalars['Int']['output'];
  token: Scalars['String']['output'];
  transactionStatus: Scalars['String']['output'];
};

export type PromoCodeType = Node & {
  __typename?: 'PromoCodeType';
  availability: Scalars['Boolean']['output'];
  conditionsAfterVerification: Array<ConditionAfterVerificationType>;
  description: Scalars['String']['output'];
  endDate: Maybe<Scalars['Date']['output']>;
  /** The Globally Unique ID of this object */
  id: Scalars['ID']['output'];
  localValue: Scalars['Decimal']['output'];
  name: Scalars['String']['output'];
  pk: Scalars['Int']['output'];
  startDate: Scalars['Date']['output'];
  style: Scalars['JSON']['output'];
  token: Scalars['String']['output'];
  validCartProducts: Array<ProductType>;
  value: Scalars['Decimal']['output'];
  valueType: Scalars['String']['output'];
};

/** A connection to a list of items. */
export type PromoCodeTypeConnection = {
  __typename?: 'PromoCodeTypeConnection';
  /** Contains the nodes in this connection */
  edges: Array<PromoCodeTypeEdge>;
  /** Pagination data for this connection */
  pageInfo: PageInfo;
  /** Total quantity of existing nodes. */
  totalCount: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type PromoCodeTypeEdge = {
  __typename?: 'PromoCodeTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: PromoCodeType;
};

export type Query = {
  __typename?: 'Query';
  ad: Maybe<AdType>;
  address: Maybe<AddressType>;
  addresses: AddressTypeConnection;
  ads: AdTypeConnection;
  authorizationKeyList: Array<AuthorizationKeyType>;
  balanceTransactions: BalanceTransactionTypeConnection;
  blog: Maybe<BlogType>;
  blogArticle: Maybe<BlogArticleType>;
  blogArticleList: BlogArticleTypeConnection;
  blogArticleListPagination: BlogArticleTypeOffsetPaginated;
  blogCategory: Maybe<BlogCategoryType>;
  blogCategoryList: BlogCategoryTypeConnection;
  blogList: BlogTypeConnection;
  cart: CartType;
  cartLine: Maybe<CartLineType>;
  cartLines: CartLineTypeOffsetPaginated;
  categories: Array<CategoryType>;
  categoriesProductsCount: Array<CategoryProductsCountType>;
  category: Maybe<CategoryType>;
  checkoutPaymentCredentials: PaymentMethodCredentialsTypeConnection;
  checkoutPaymentMethods: PaymentMethodTypeConnection;
  collection: Maybe<CollectionType>;
  collections: CollectionTypeConnection;
  countryAreas: Array<Scalars['String']['output']>;
  credits: ProductTypeConnection;
  currentCurrencyExchangeRate: Maybe<CurrencyExchangeRateType>;
  customer: Maybe<MarketplaceCustomerType>;
  echo: Scalars['String']['output'];
  feedbackList: FeedbackTypeOffsetPaginated;
  flatpage: Maybe<FlatPageType>;
  flatpages: FlatPageTypeConnection;
  giftCardCode: Maybe<VoucherTransactionType>;
  giftCardList: VoucherTypeConnection;
  marketingCode: Maybe<MarketingCodeType>;
  marketingInfo: MarketingInfoType;
  marketplaces: MarketplaceShopTypeConnection;
  me: Maybe<UserType>;
  offerList: OfferTypeConnection;
  order: Maybe<OrderType>;
  orderNotes: OrderNoteTypeConnection;
  orders: OrderTypeConnection;
  patternPacks: ProductTypeConnection;
  ping: Scalars['String']['output'];
  product: Maybe<ProductType>;
  productSuggestions: Array<ProductSuggestionType>;
  productVariant: Maybe<ProductVariantType>;
  productVariants: ProductVariantTypeConnection;
  products: ProductTypeConnection;
  productsFilterSchema: FilterSchemaType;
  promoCode: Maybe<PromoCodeType>;
  promoCodes: PromoCodeTypeConnection;
  randomAd: Maybe<AdType>;
  redirect: Maybe<RedirectType>;
  reflectionDetails: Maybe<ReflectionDetailsType>;
  rewardPrograms: RewardProgramTypeConnection;
  saleList: SaleTypeConnection;
  shippingMethodCountries: ShippingMethodCountryTypeConnection;
  siteSettings: SiteSettingsType;
  socialPost: Maybe<PostType>;
  socialPosts: PostTypeConnection;
  specific: Maybe<ProductSiteSpecificsType>;
  specifics: ProductSiteSpecificsTypeConnection;
  subscriptionTypes: Array<CustomerSubscriptionType>;
  userTranslation: Maybe<UserTranslationType>;
  userTranslations: UserTranslationTypeConnection;
  viewerUsername: Maybe<Scalars['String']['output']>;
  wholesaleApp: Maybe<WholesaleAppType>;
  wholesaleProduct: Maybe<WholesaleProductType>;
  wholesaleProducts: WholesaleProductTypeConnection;
};


export type QueryAdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAddressArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAddressesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAdsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<AdFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryBalanceTransactionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<BalanceTransactionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryBlogArgs = {
  filters?: InputMaybe<BlogFilter>;
};


export type QueryBlogArticleArgs = {
  filters?: InputMaybe<BlogArticleFilter>;
};


export type QueryBlogArticleListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<BlogArticleFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  ordering?: Array<BlogArticleOrder>;
};


export type QueryBlogArticleListPaginationArgs = {
  filters?: InputMaybe<BlogArticleFilter>;
  ordering?: Array<BlogArticleOrder>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};


export type QueryBlogCategoryArgs = {
  filters?: InputMaybe<BlogCategoryFilter>;
};


export type QueryBlogCategoryListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<BlogCategoryFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryBlogListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<BlogFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCartArgs = {
  cartType?: CartTypeEnum;
};


export type QueryCartLineArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCartLinesArgs = {
  cartType?: CartTypeEnum;
  filters?: InputMaybe<CartLineFilter>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};


export type QueryCategoryArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCheckoutPaymentCredentialsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCheckoutPaymentMethodsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCollectionArgs = {
  slug: Scalars['String']['input'];
};


export type QueryCollectionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<CollectionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCountryAreasArgs = {
  code: CountryCodeEnum;
};


export type QueryCreditsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<ProductFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCustomerArgs = {
  activationCode: Scalars['String']['input'];
};


export type QueryEchoArgs = {
  text: Scalars['String']['input'];
};


export type QueryFeedbackListArgs = {
  filters?: InputMaybe<FeedbackFilter>;
  ordering?: Array<FeedbackOrder>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};


export type QueryFlatpageArgs = {
  url: Scalars['String']['input'];
};


export type QueryFlatpagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<FlatPageFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGiftCardCodeArgs = {
  captcha: Scalars['String']['input'];
  code: Scalars['String']['input'];
};


export type QueryGiftCardListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<VoucherFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMarketingCodeArgs = {
  captcha: Scalars['String']['input'];
};


export type QueryMarketingInfoArgs = {
  salesChannelName?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMarketplacesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryOfferListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryOrderArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  pubId?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
};


export type QueryOrderNotesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<OrderNoteFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryOrdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<OrderFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPatternPacksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<ProductFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryProductArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProductSuggestionsArgs = {
  category?: InputMaybe<Scalars['String']['input']>;
  q: Scalars['String']['input'];
  size?: Scalars['Int']['input'];
};


export type QueryProductVariantArgs = {
  attrs?: InputMaybe<Array<VariantAttrsInput>>;
  pk?: InputMaybe<Scalars['Int']['input']>;
  productPk?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryProductVariantsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<ProductVariantFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<ProductFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryProductsFilterSchemaArgs = {
  attributes?: InputMaybe<Array<AttributeInputType>>;
  cartToken?: InputMaybe<Scalars['UUID']['input']>;
  category?: InputMaybe<Scalars['ID']['input']>;
  collection?: InputMaybe<Scalars['String']['input']>;
  isWholesale?: InputMaybe<Scalars['Boolean']['input']>;
  price0?: InputMaybe<Scalars['Int']['input']>;
  price1?: InputMaybe<Scalars['Int']['input']>;
  product_Variants_Sales?: InputMaybe<Array<Scalars['ID']['input']>>;
  promoCode?: InputMaybe<Array<Scalars['ID']['input']>>;
  q?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPromoCodeArgs = {
  captcha: Scalars['String']['input'];
  code: Scalars['String']['input'];
  countryCode: CountryCodeEnum;
  email?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPromoCodesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<PromoCodeFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryRandomAdArgs = {
  filters?: InputMaybe<AdFilter>;
};


export type QueryRedirectArgs = {
  slug: Scalars['String']['input'];
};


export type QueryReflectionDetailsArgs = {
  id: Scalars['ID']['input'];
};


export type QueryRewardProgramsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<RewardProgramFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySaleListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<SaleFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryShippingMethodCountriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<ShippingMethodCountryFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySocialPostArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QuerySocialPostsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<SocialPostFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  ordering?: Array<SocialPostOrder>;
};


export type QuerySpecificArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySpecificsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<ProductSiteSpecificsFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  ordering?: Array<ProductSiteSpecificsOrder>;
};


export type QueryUserTranslationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryUserTranslationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<UserTranslationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryWholesaleAppArgs = {
  id: Scalars['ID']['input'];
};


export type QueryWholesaleProductArgs = {
  slug: Scalars['String']['input'];
};


export type QueryWholesaleProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type RangeType = {
  __typename?: 'RangeType';
  max: Scalars['Float']['output'];
  min: Scalars['Float']['output'];
};

export type RedirectType = Node & {
  __typename?: 'RedirectType';
  /** The Globally Unique ID of this object */
  id: Scalars['ID']['output'];
  newPath: Scalars['String']['output'];
  oldPath: Scalars['String']['output'];
  pk: Scalars['Int']['output'];
};

export type ReflectionDetailsType = {
  __typename?: 'ReflectionDetailsType';
  redirectUrl: Maybe<Scalars['String']['output']>;
  reflection: Maybe<ProductSiteSpecificsType>;
};

export type ResetPasswordMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
};

export type RewardDollarsType = Node & {
  __typename?: 'RewardDollarsType';
  amount: Scalars['Decimal']['output'];
  amountSpent: Scalars['Decimal']['output'];
  dateCreated: Scalars['DateTime']['output'];
  daysActive: Scalars['Int']['output'];
  /** The Globally Unique ID of this object */
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  pk: Scalars['Int']['output'];
  pointsAmount: Scalars['Float']['output'];
  pointsAmountSpent: Scalars['Float']['output'];
  program: RewardProgramType;
  rewardPoints: Maybe<RewardPointsType>;
};

export type RewardDollarsTypeOffsetPaginated = {
  __typename?: 'RewardDollarsTypeOffsetPaginated';
  pageInfo: OffsetPaginationInfo;
  /** List of paginated results. */
  results: Array<RewardDollarsType>;
  /** Total count of existing results. */
  totalCount: Scalars['Int']['output'];
};

export type RewardPointsType = Node & {
  __typename?: 'RewardPointsType';
  amount: Scalars['Decimal']['output'];
  amountSpent: Scalars['Decimal']['output'];
  dateCreated: Scalars['Date']['output'];
  daysActive: Maybe<Scalars['Int']['output']>;
  /** The Globally Unique ID of this object */
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  pk: Scalars['Int']['output'];
  program: RewardProgramType;
};

export type RewardPointsTypeOffsetPaginated = {
  __typename?: 'RewardPointsTypeOffsetPaginated';
  pageInfo: OffsetPaginationInfo;
  /** List of paginated results. */
  results: Array<RewardPointsType>;
  /** Total count of existing results. */
  totalCount: Scalars['Int']['output'];
};

export type RewardProgramFilter = {
  AND?: InputMaybe<RewardProgramFilter>;
  DISTINCT?: InputMaybe<Scalars['Boolean']['input']>;
  NOT?: InputMaybe<RewardProgramFilter>;
  OR?: InputMaybe<RewardProgramFilter>;
  id?: InputMaybe<IdBaseFilterLookup>;
  name?: InputMaybe<StrFilterLookup>;
};

export type RewardProgramType = Node & {
  __typename?: 'RewardProgramType';
  availableFrom: Maybe<Scalars['Date']['output']>;
  availableTo: Maybe<Scalars['Date']['output']>;
  coefficient: Scalars['Int']['output'];
  dateCreated: Scalars['Date']['output'];
  daysActive: Scalars['Int']['output'];
  description: Scalars['String']['output'];
  /** The Globally Unique ID of this object */
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  pk: Scalars['Int']['output'];
  rdThreshold: Maybe<Scalars['Int']['output']>;
  rpThreshold: Scalars['Float']['output'];
  thumbnailUrl: Maybe<Scalars['String']['output']>;
};


export type RewardProgramTypeThumbnailUrlArgs = {
  method?: VersatileImageMethodEnum;
  size?: Scalars['String']['input'];
};

/** A connection to a list of items. */
export type RewardProgramTypeConnection = {
  __typename?: 'RewardProgramTypeConnection';
  /** Contains the nodes in this connection */
  edges: Array<RewardProgramTypeEdge>;
  /** Pagination data for this connection */
  pageInfo: PageInfo;
  /** Total quantity of existing nodes. */
  totalCount: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type RewardProgramTypeEdge = {
  __typename?: 'RewardProgramTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: RewardProgramType;
};

export type SaleFilter = {
  AND?: InputMaybe<SaleFilter>;
  DISTINCT?: InputMaybe<Scalars['Boolean']['input']>;
  NOT?: InputMaybe<SaleFilter>;
  OR?: InputMaybe<SaleFilter>;
  id?: InputMaybe<IdBaseFilterLookup>;
  name?: InputMaybe<StrFilterLookup>;
};

export type SaleSchemaType = Node & {
  __typename?: 'SaleSchemaType';
  count: Scalars['Int']['output'];
  /** The Globally Unique ID of this object */
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  pk: Scalars['Int']['output'];
};

export type SaleType = Node & {
  __typename?: 'SaleType';
  availableFrom: Maybe<Scalars['Date']['output']>;
  availableTo: Scalars['Date']['output'];
  categories: Array<CategoryType>;
  /** The Globally Unique ID of this object */
  id: Scalars['ID']['output'];
  localAmount: Scalars['Decimal']['output'];
  name: Scalars['String']['output'];
  pk: Scalars['Int']['output'];
  type: Scalars['String']['output'];
  value: Scalars['Decimal']['output'];
};


export type SaleTypeCategoriesArgs = {
  filters?: InputMaybe<CategoryFilter>;
};

/** A connection to a list of items. */
export type SaleTypeConnection = {
  __typename?: 'SaleTypeConnection';
  /** Contains the nodes in this connection */
  edges: Array<SaleTypeEdge>;
  /** Pagination data for this connection */
  pageInfo: PageInfo;
  /** Total quantity of existing nodes. */
  totalCount: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type SaleTypeEdge = {
  __typename?: 'SaleTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: SaleType;
};

export type SetCurrencyPayload = {
  __typename?: 'SetCurrencyPayload';
  currency: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type SetLanguageInput = {
  language: Scalars['String']['input'];
};

export type SetLanguageMutationPayload = {
  __typename?: 'SetLanguageMutationPayload';
  errors: Array<ErrorType>;
};

export type ShippingDiscountType = Node & {
  __typename?: 'ShippingDiscountType';
  discountType: DiscountTypeEnum;
  /** The Globally Unique ID of this object */
  id: Scalars['ID']['output'];
  isCurrent: Scalars['Boolean']['output'];
  localValue: Scalars['Decimal']['output'];
  maxValue: Scalars['Float']['output'];
  minValue: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  pk: Scalars['Int']['output'];
  shippingMethods: ShippingMethodType;
  value: Scalars['Float']['output'];
};

export type ShippingMethodCountryFilter = {
  AND?: InputMaybe<ShippingMethodCountryFilter>;
  DISTINCT?: InputMaybe<Scalars['Boolean']['input']>;
  NOT?: InputMaybe<ShippingMethodCountryFilter>;
  OR?: InputMaybe<ShippingMethodCountryFilter>;
  countryCode?: InputMaybe<CountryCodeEnum>;
  shippingMethod?: InputMaybe<ShippingMethodFilter>;
};

export type ShippingMethodCountryType = Node & {
  __typename?: 'ShippingMethodCountryType';
  countryCode: Maybe<CountryCodeEnum>;
  /** The Globally Unique ID of this object */
  id: Scalars['ID']['output'];
  pk: Scalars['Int']['output'];
  shippingMethod: ShippingMethodType;
  shippingTime: Scalars['String']['output'];
};

/** A connection to a list of items. */
export type ShippingMethodCountryTypeConnection = {
  __typename?: 'ShippingMethodCountryTypeConnection';
  /** Contains the nodes in this connection */
  edges: Array<ShippingMethodCountryTypeEdge>;
  /** Pagination data for this connection */
  pageInfo: PageInfo;
  /** Total quantity of existing nodes. */
  totalCount: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type ShippingMethodCountryTypeEdge = {
  __typename?: 'ShippingMethodCountryTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: ShippingMethodCountryType;
};

export type ShippingMethodFilter = {
  AND?: InputMaybe<ShippingMethodFilter>;
  DISTINCT?: InputMaybe<Scalars['Boolean']['input']>;
  NOT?: InputMaybe<ShippingMethodFilter>;
  OR?: InputMaybe<ShippingMethodFilter>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ShippingMethodType = Node & {
  __typename?: 'ShippingMethodType';
  active: Scalars['Boolean']['output'];
  description: Scalars['String']['output'];
  /** The Globally Unique ID of this object */
  id: Scalars['ID']['output'];
  isExpress: Scalars['Boolean']['output'];
  isPhoneRequired: Scalars['Boolean']['output'];
  maxParcelWeight: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  pk: Scalars['Int']['output'];
  sortOrder: Maybe<Scalars['Int']['output']>;
  trackingType: Maybe<Scalars['String']['output']>;
};

export type SignInMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

export type SignInMutationPayload = {
  __typename?: 'SignInMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<ErrorType>;
  me: Maybe<UserType>;
};

export type SignUpMutationInput = {
  captcha: Scalars['String']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  policyAgreement: Scalars['Boolean']['input'];
  subscriptions?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SignUpMutationPayload = {
  __typename?: 'SignUpMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<ErrorType>;
  me: Maybe<UserType>;
};

export type SiteSettingsType = Node & {
  __typename?: 'SiteSettingsType';
  bannerCategories: Array<BannerCategoryType>;
  copyrightText: Scalars['String']['output'];
  defaultFromEmail: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  googleAnalyticsId: Maybe<Scalars['String']['output']>;
  headerText: Scalars['String']['output'];
  /** The Globally Unique ID of this object */
  id: Scalars['ID']['output'];
  keywords: Scalars['String']['output'];
  managerEmail: Maybe<Scalars['String']['output']>;
  metaTitle: Scalars['String']['output'];
  pk: Scalars['Int']['output'];
  site: SiteType;
  templatePrefix: Scalars['String']['output'];
};

export type SiteType = Node & {
  __typename?: 'SiteType';
  footerBlocks: Array<FooterBlockType>;
  /** The Globally Unique ID of this object */
  id: Scalars['ID']['output'];
  images: Array<BannerImageType>;
  name: Scalars['String']['output'];
  pk: Scalars['Int']['output'];
};

export type SocialAuthPayload = {
  __typename?: 'SocialAuthPayload';
  me: Maybe<UserType>;
  user: Maybe<UserType>;
};

export type SocialPostCreatePayload = {
  __typename?: 'SocialPostCreatePayload';
  errors: Array<ErrorType>;
  post: Maybe<PostType>;
};

export type SocialPostFilter = {
  AND?: InputMaybe<SocialPostFilter>;
  DISTINCT?: InputMaybe<Scalars['Boolean']['input']>;
  NOT?: InputMaybe<SocialPostFilter>;
  OR?: InputMaybe<SocialPostFilter>;
  created?: InputMaybe<DatetimeDatetimeFilterLookup>;
  name?: InputMaybe<StrFilterLookup>;
  sortOrder?: InputMaybe<IntComparisonFilterLookup>;
};

export type SocialPostImageType = Node & {
  __typename?: 'SocialPostImageType';
  alt: Scalars['String']['output'];
  /** The Globally Unique ID of this object */
  id: Scalars['ID']['output'];
  order: Scalars['Int']['output'];
  thumbnailUrl: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};


export type SocialPostImageTypeThumbnailUrlArgs = {
  method?: VersatileImageMethodEnum;
  size?: Scalars['String']['input'];
};

export type SocialPostInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  externalLink?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  relatedProducts?: InputMaybe<Array<Scalars['Int']['input']>>;
  type: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

export type SocialPostOrder = {
  created?: InputMaybe<Ordering>;
  name?: InputMaybe<Ordering>;
};

export enum StoreTypeEnum {
  BothOnline = 'BOTH_ONLINE',
  BrickAndMortar = 'BRICK_AND_MORTAR',
  Online = 'ONLINE'
}

export type StrFilterLookup = {
  /** Case-sensitive containment test. Filter will be skipped on `null` value */
  contains?: InputMaybe<Scalars['String']['input']>;
  /** Case-sensitive ends-with. Filter will be skipped on `null` value */
  endsWith?: InputMaybe<Scalars['String']['input']>;
  /** Exact match. Filter will be skipped on `null` value */
  exact?: InputMaybe<Scalars['String']['input']>;
  /** Case-insensitive containment test. Filter will be skipped on `null` value */
  iContains?: InputMaybe<Scalars['String']['input']>;
  /** Case-insensitive ends-with. Filter will be skipped on `null` value */
  iEndsWith?: InputMaybe<Scalars['String']['input']>;
  /** Case-insensitive exact match. Filter will be skipped on `null` value */
  iExact?: InputMaybe<Scalars['String']['input']>;
  /** Case-insensitive regular expression match. Filter will be skipped on `null` value */
  iRegex?: InputMaybe<Scalars['String']['input']>;
  /** Case-insensitive starts-with. Filter will be skipped on `null` value */
  iStartsWith?: InputMaybe<Scalars['String']['input']>;
  /** Exact match of items in a given list. Filter will be skipped on `null` value */
  inList?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Assignment test. Filter will be skipped on `null` value */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Case-sensitive regular expression match. Filter will be skipped on `null` value */
  regex?: InputMaybe<Scalars['String']['input']>;
  /** Case-sensitive starts-with. Filter will be skipped on `null` value */
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type SubmissionAnalyticsPayload = {
  __typename?: 'SubmissionAnalyticsPayload';
  errors: Array<ErrorType>;
};

export enum SubscriptionTypeEnum {
  Announcements = 'ANNOUNCEMENTS',
  FreePatterns = 'FREE_PATTERNS',
  Marketing = 'MARKETING',
  Newsletter = 'NEWSLETTER',
  Sales = 'SALES',
  Service = 'SERVICE',
  Unsubscribed = 'UNSUBSCRIBED'
}

export type SupplyProductFilter = {
  AND?: InputMaybe<SupplyProductFilter>;
  DISTINCT?: InputMaybe<Scalars['Boolean']['input']>;
  NOT?: InputMaybe<SupplyProductFilter>;
  OR?: InputMaybe<SupplyProductFilter>;
  isWholesale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SupplyProductType = Node & {
  __typename?: 'SupplyProductType';
  /** The Globally Unique ID of this object */
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  pk: Scalars['Int']['output'];
  product: ProductType;
  sortOrder: Scalars['Int']['output'];
  supplyVariants: Array<SupplyVariantType>;
  variant: ProductVariantType;
};

export type SupplyVariantType = Node & {
  __typename?: 'SupplyVariantType';
  /** The Globally Unique ID of this object */
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  pk: Scalars['Int']['output'];
  product: SupplyProductType;
  variant: ProductVariantType;
};

export type ThumbnailType = {
  __typename?: 'ThumbnailType';
  lg: Maybe<Scalars['String']['output']>;
  md: Maybe<Scalars['String']['output']>;
  sm: Maybe<Scalars['String']['output']>;
};


export type ThumbnailTypeLgArgs = {
  method?: VersatileImageMethodEnum;
  size?: Scalars['String']['input'];
};


export type ThumbnailTypeMdArgs = {
  method?: VersatileImageMethodEnum;
  size?: Scalars['String']['input'];
};


export type ThumbnailTypeSmArgs = {
  method?: VersatileImageMethodEnum;
  size?: Scalars['String']['input'];
};

export type TransactionFilter = {
  AND?: InputMaybe<TransactionFilter>;
  DISTINCT?: InputMaybe<Scalars['Boolean']['input']>;
  NOT?: InputMaybe<TransactionFilter>;
  OR?: InputMaybe<TransactionFilter>;
  date?: InputMaybe<DatetimeDatetimeFilterLookup>;
};

export type TransactionType = Node & {
  __typename?: 'TransactionType';
  amount: Scalars['Float']['output'];
  date: Scalars['DateTime']['output'];
  feeAmt: Scalars['Float']['output'];
  feeDetails: Scalars['JSON']['output'];
  /** The Globally Unique ID of this object */
  id: Scalars['ID']['output'];
  pk: Scalars['Int']['output'];
  transactionId: Maybe<Scalars['String']['output']>;
  transactionType: TransactionTypeEnum;
};

export enum TransactionTypeEnum {
  Expense = 'EXPENSE',
  Receivement = 'RECEIVEMENT'
}

export type TransactionTypeOffsetPaginated = {
  __typename?: 'TransactionTypeOffsetPaginated';
  pageInfo: OffsetPaginationInfo;
  /** List of paginated results. */
  results: Array<TransactionType>;
  /** Total count of existing results. */
  totalCount: Scalars['Int']['output'];
};

export type TransferOrderToCheckoutMutationPayload = {
  __typename?: 'TransferOrderToCheckoutMutationPayload';
  errors: Array<Scalars['String']['output']>;
};

export enum TranslationStatusEnum {
  Approved = 'APPROVED',
  FullyTranslated = 'FULLY_TRANSLATED',
  NotTranslated = 'NOT_TRANSLATED',
  PartiallyTranslated = 'PARTIALLY_TRANSLATED'
}

export type UpdateUserTranslationInput = {
  currentText: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  status: TranslationStatusEnum;
};

export type UpdateUserTranslationMutationPayload = {
  __typename?: 'UpdateUserTranslationMutationPayload';
  errors: Array<ErrorType>;
  translation: Maybe<UserTranslationType>;
};

export type UserFileDownloadsType = Node & {
  __typename?: 'UserFileDownloadsType';
  attemptsRemaining: Scalars['Int']['output'];
  downloadLink: Scalars['String']['output'];
  downloadable: Scalars['Boolean']['output'];
  fileName: Scalars['String']['output'];
  /** The Globally Unique ID of this object */
  id: Scalars['ID']['output'];
  isOneTime: Scalars['Boolean']['output'];
  lastDownload: Maybe<Scalars['DateTime']['output']>;
  maxDownloads: Scalars['Int']['output'];
  numAttempts: Scalars['Int']['output'];
  pk: Scalars['Int']['output'];
  size: Scalars['Int']['output'];
};

export type UserPatternTransactionFilter = {
  AND?: InputMaybe<UserPatternTransactionFilter>;
  DISTINCT?: InputMaybe<Scalars['Boolean']['input']>;
  NOT?: InputMaybe<UserPatternTransactionFilter>;
  OR?: InputMaybe<UserPatternTransactionFilter>;
  transactionType?: InputMaybe<TransactionTypeEnum>;
};

export type UserPatternTransactionType = Node & {
  __typename?: 'UserPatternTransactionType';
  date: Scalars['DateTime']['output'];
  descriptionText: Scalars['String']['output'];
  /** The Globally Unique ID of this object */
  id: Scalars['ID']['output'];
  order: Maybe<OrderType>;
  patternType: Scalars['String']['output'];
  patternsCount: Scalars['Int']['output'];
  pk: Scalars['Int']['output'];
  transactionType: TransactionTypeEnum;
};

export type UserPatternTransactionTypeOffsetPaginated = {
  __typename?: 'UserPatternTransactionTypeOffsetPaginated';
  pageInfo: OffsetPaginationInfo;
  /** List of paginated results. */
  results: Array<UserPatternTransactionType>;
  /** Total count of existing results. */
  totalCount: Scalars['Int']['output'];
};

export type UserTranslationFilter = {
  AND?: InputMaybe<UserTranslationFilter>;
  DISTINCT?: InputMaybe<Scalars['Boolean']['input']>;
  NOT?: InputMaybe<UserTranslationFilter>;
  OR?: InputMaybe<UserTranslationFilter>;
  entityId?: InputMaybe<Scalars['Int']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  fieldName?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<LanguageEnum>;
  status?: InputMaybe<TranslationStatusEnum>;
  user?: InputMaybe<DjangoModelFilterInput>;
};

export type UserTranslationType = Node & {
  __typename?: 'UserTranslationType';
  currentText: Scalars['String']['output'];
  entityId: Maybe<Scalars['Int']['output']>;
  entityType: Scalars['String']['output'];
  fieldName: Scalars['String']['output'];
  /** The Globally Unique ID of this object */
  id: Scalars['ID']['output'];
  language: LanguageEnum;
  originalText: Scalars['String']['output'];
  pk: Scalars['Int']['output'];
  status: TranslationStatusEnum;
};

/** A connection to a list of items. */
export type UserTranslationTypeConnection = {
  __typename?: 'UserTranslationTypeConnection';
  /** Contains the nodes in this connection */
  edges: Array<UserTranslationTypeEdge>;
  /** Pagination data for this connection */
  pageInfo: PageInfo;
  /** Total quantity of existing nodes. */
  totalCount: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type UserTranslationTypeEdge = {
  __typename?: 'UserTranslationTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: UserTranslationType;
};

export type UserType = Node & {
  __typename?: 'UserType';
  addresses: Array<AddressType>;
  analyticsId: Scalars['String']['output'];
  customer: MarketplaceCustomerType;
  dateJoined: Scalars['DateTime']['output'];
  downloads: DownloadTypeOffsetPaginated;
  email: Scalars['String']['output'];
  favoritesCategoriesInfo: Array<FavoritesCategoriesInfoType>;
  firstName: Scalars['String']['output'];
  /** The Globally Unique ID of this object */
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  isImpersonate: Scalars['Boolean']['output'];
  isStaff: Scalars['Boolean']['output'];
  isSuperuser: Scalars['Boolean']['output'];
  lastName: Scalars['String']['output'];
  minRpThreshold: Scalars['Int']['output'];
  orders: OrderTypeOffsetPaginated;
  ordersCountInfo: OrdersCountInfoType;
  patternPacksInfo: Array<PatternPacksInfoType>;
  patternTransactions: UserPatternTransactionTypeOffsetPaginated;
  permissions: Array<Scalars['String']['output']>;
  pk: Scalars['Int']['output'];
  rewardDollars: RewardDollarsTypeOffsetPaginated;
  rewardPoints: RewardPointsTypeOffsetPaginated;
  subscriptions: Scalars['Boolean']['output'];
  totalBalance: PriceType;
  totalBalanceAvailable: PriceType;
  totalPointsBalance: Scalars['Float']['output'];
  totalPointsBalanceAvailable: Scalars['Float']['output'];
  transactions: TransactionTypeOffsetPaginated;
  wholesaleApp: Maybe<WholesaleAppType>;
  wishedProducts: ProductTypeOffsetPaginated;
};


export type UserTypeDownloadsArgs = {
  pagination?: InputMaybe<OffsetPaginationInput>;
};


export type UserTypeOrdersArgs = {
  filters?: InputMaybe<OrderFilter>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};


export type UserTypeOrdersCountInfoArgs = {
  cartType?: InputMaybe<CartTypeEnum>;
};


export type UserTypePatternTransactionsArgs = {
  filters?: InputMaybe<UserPatternTransactionFilter>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};


export type UserTypeRewardDollarsArgs = {
  pagination?: InputMaybe<OffsetPaginationInput>;
};


export type UserTypeRewardPointsArgs = {
  pagination?: InputMaybe<OffsetPaginationInput>;
};


export type UserTypeTransactionsArgs = {
  filters?: InputMaybe<TransactionFilter>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};


export type UserTypeWishedProductsArgs = {
  filters?: InputMaybe<ProductFilter>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};

export type VariantAttrsInput = {
  attrName?: InputMaybe<Scalars['String']['input']>;
  valueName?: InputMaybe<Scalars['String']['input']>;
};

export type VariantPriceRangeType = {
  __typename?: 'VariantPriceRangeType';
  currency: Scalars['String']['output'];
  discount: RangeType;
  id: Scalars['ID']['output'];
  undiscount: RangeType;
};

export type VariationPropertyType = {
  __typename?: 'VariationPropertyType';
  attributeName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  pk: Scalars['Int']['output'];
  sortOrder: Maybe<Scalars['Int']['output']>;
  stockStatus: OutOfStockStatusEnum;
  valueName: Scalars['String']['output'];
  variation: Scalars['Int']['output'];
};

export enum VersatileImageMethodEnum {
  Crop = 'CROP',
  CropWebp = 'CROP_WEBP',
  Thumbnail = 'THUMBNAIL',
  ThumbnailWebp = 'THUMBNAIL_WEBP'
}

export type VoucherFilter = {
  AND?: InputMaybe<VoucherFilter>;
  DISTINCT?: InputMaybe<Scalars['Boolean']['input']>;
  NOT?: InputMaybe<VoucherFilter>;
  OR?: InputMaybe<VoucherFilter>;
  name?: InputMaybe<StrFilterLookup>;
};

export type VoucherTransactionFilter = {
  AND?: InputMaybe<VoucherTransactionFilter>;
  DISTINCT?: InputMaybe<Scalars['Boolean']['input']>;
  NOT?: InputMaybe<VoucherTransactionFilter>;
  OR?: InputMaybe<VoucherTransactionFilter>;
  amount?: InputMaybe<DecimalComparisonFilterLookup>;
  email?: InputMaybe<StrFilterLookup>;
  isActive?: InputMaybe<BoolBaseFilterLookup>;
};

export type VoucherTransactionType = Node & {
  __typename?: 'VoucherTransactionType';
  amount: Scalars['Decimal']['output'];
  availableBalance: Scalars['Float']['output'];
  balanceData: Scalars['JSON']['output'];
  date: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  expires: Scalars['DateTime']['output'];
  /** The Globally Unique ID of this object */
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  pk: Scalars['Int']['output'];
  transactionStatus: Scalars['String']['output'];
  transactionType: TransactionTypeEnum;
  voucherCode: Scalars['String']['output'];
};

export type VoucherType = Node & {
  __typename?: 'VoucherType';
  daysActive: Scalars['Int']['output'];
  /** The Globally Unique ID of this object */
  id: Scalars['ID']['output'];
  localPrice: Scalars['Decimal']['output'];
  name: Maybe<Scalars['String']['output']>;
  pk: Scalars['Int']['output'];
  price: Scalars['Decimal']['output'];
  voucherProduct: ProductType;
};

/** A connection to a list of items. */
export type VoucherTypeConnection = {
  __typename?: 'VoucherTypeConnection';
  /** Contains the nodes in this connection */
  edges: Array<VoucherTypeEdge>;
  /** Pagination data for this connection */
  pageInfo: PageInfo;
  /** Total quantity of existing nodes. */
  totalCount: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type VoucherTypeEdge = {
  __typename?: 'VoucherTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: VoucherType;
};

export type WholesaleAppAddressInput = {
  city: Scalars['String']['input'];
  country: CountryCodeEnum;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
};

export type WholesaleAppAddressType = {
  __typename?: 'WholesaleAppAddressType';
  city: Maybe<Scalars['String']['output']>;
  country: Maybe<CountryCodeEnum>;
  firstName: Maybe<Scalars['String']['output']>;
  lastName: Maybe<Scalars['String']['output']>;
};

export type WholesaleAppCreateMutationPayload = {
  __typename?: 'WholesaleAppCreateMutationPayload';
  errors: Array<ErrorType>;
  wholesaleApp: Maybe<WholesaleAppType>;
};

export type WholesaleAppInput = {
  brands: Array<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  facebookUrl?: InputMaybe<Scalars['String']['input']>;
  initialAddress?: InputMaybe<WholesaleAppAddressInput>;
  instagramUrl?: InputMaybe<Scalars['String']['input']>;
  storeDescription: Array<Scalars['String']['input']>;
  storeName: Scalars['String']['input'];
  storeType: StoreTypeEnum;
  storeYear?: InputMaybe<Scalars['Int']['input']>;
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
};

export enum WholesaleAppStatusEnum {
  Confirmed = 'CONFIRMED',
  Declined = 'DECLINED',
  Pending = 'PENDING'
}

export type WholesaleAppType = Node & {
  __typename?: 'WholesaleAppType';
  brands: Array<Scalars['String']['output']>;
  created: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  facebookUrl: Maybe<Scalars['String']['output']>;
  /** The Globally Unique ID of this object */
  id: Scalars['ID']['output'];
  initialAddress: Maybe<WholesaleAppAddressType>;
  instagramUrl: Maybe<Scalars['String']['output']>;
  pk: Scalars['Int']['output'];
  status: WholesaleAppStatusEnum;
  storeDescription: Array<Scalars['String']['output']>;
  storeName: Scalars['String']['output'];
  storeType: StoreTypeEnum;
  storeYear: Maybe<Scalars['Int']['output']>;
  websiteUrl: Maybe<Scalars['String']['output']>;
};

export type WholesaleCheckoutFormInput = {
  address: Scalars['Int']['input'];
  billingAddress?: InputMaybe<Scalars['Int']['input']>;
  cartShipmentId?: InputMaybe<Scalars['Int']['input']>;
  email: Scalars['String']['input'];
  isDraft?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<WholesaleCheckoutNotesFormInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  shippingMethod: Scalars['Int']['input'];
};

export type WholesaleCheckoutMutationPayload = {
  __typename?: 'WholesaleCheckoutMutationPayload';
  errors: Array<ErrorType>;
  order: Maybe<OrderType>;
};

export type WholesaleCheckoutNotesFormInput = {
  content: Scalars['String']['input'];
  replyToMe?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WholesaleProductElementImageType = Node & {
  __typename?: 'WholesaleProductElementImageType';
  height: Scalars['Int']['output'];
  /** The Globally Unique ID of this object */
  id: Scalars['ID']['output'];
  image: Scalars['String']['output'];
  pk: Scalars['Int']['output'];
  sortOrder: Scalars['Int']['output'];
  thumbnailUrl: Maybe<Scalars['String']['output']>;
  width: Scalars['Int']['output'];
};


export type WholesaleProductElementImageTypeThumbnailUrlArgs = {
  method?: VersatileImageMethodEnum;
  size?: Scalars['String']['input'];
};

export type WholesaleProductElementType = Node & {
  __typename?: 'WholesaleProductElementType';
  description: Scalars['String']['output'];
  /** The Globally Unique ID of this object */
  id: Scalars['ID']['output'];
  images: Array<WholesaleProductElementImageType>;
  name: Scalars['String']['output'];
  pk: Scalars['Int']['output'];
  slug: Scalars['String']['output'];
  sortOrder: Scalars['Int']['output'];
};

export type WholesaleProductType = Node & {
  __typename?: 'WholesaleProductType';
  category: Maybe<CategoryType>;
  created: Scalars['DateTime']['output'];
  description: Scalars['JSON']['output'];
  elements: Array<WholesaleProductElementType>;
  /** The Globally Unique ID of this object */
  id: Scalars['ID']['output'];
  isPublished: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  pk: Scalars['Int']['output'];
  rectangularImage: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  sortOrder: Scalars['Int']['output'];
  squareImage: Maybe<Scalars['String']['output']>;
};


export type WholesaleProductTypeRectangularImageArgs = {
  method?: VersatileImageMethodEnum;
  size?: Scalars['String']['input'];
};


export type WholesaleProductTypeSquareImageArgs = {
  method?: VersatileImageMethodEnum;
  size?: Scalars['String']['input'];
};

/** A connection to a list of items. */
export type WholesaleProductTypeConnection = {
  __typename?: 'WholesaleProductTypeConnection';
  /** Contains the nodes in this connection */
  edges: Array<WholesaleProductTypeEdge>;
  /** Pagination data for this connection */
  pageInfo: PageInfo;
  /** Total quantity of existing nodes. */
  totalCount: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type WholesaleProductTypeEdge = {
  __typename?: 'WholesaleProductTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: WholesaleProductType;
};
